(function(){
const A = window.PIXIE_ASSETS || {};
const PERSONAS = {
  citrus: { key:'citrus', mark:'citrus', name:'Citrus spark', type:'01', color:'#f0921f', tint:'#ffeeda',
    subtitle:'bold, spontaneous, always ready for the next adventure.', line1:"You don't wait for the fun.", line2:'You bring it.',
    img:A.wCitrus, photo:A.cardCitrus, life:A.cardCitrus, vibe:'Bold · social · spontaneous',
    blurb:"sitting still? not really your thing. citrus spark is bold, social and always ready for the next adventure." },
  mint: { key:'mint', mark:'mint', name:'Mint mischief', type:'02', color:'#7dc496', tint:'#eaf7ee',
    subtitle:'sweet on the outside, slightly chaotic underneath.', line1:'You have a plan.', line2:'Whether anyone follows it is another story.',
    img:A.wMint, photo:A.cardMint, life:A.cardMint, vibe:'Playful · clever · chaotic',
    blurb:'probably the unofficial planner, problem-solver and chaos manager of your friend group. mint mischief keeps the group chat unwell in the best possible way.' },
  daydream: { key:'daydream', mark:'daydream', name:'Dreamy pixie', type:'03', color:'#93c4d6', tint:'#e8f4f8',
    subtitle:'soft, curious, and happily lost in your own little world.', line1:'Life is better when you slow down.', line2:'And notice the little things.',
    img:A.wBlue, photo:A.cardDaydream, life:A.cardDaydream, vibe:'Dreamy · calm · curious',
    blurb:'you romanticize ordinary moments and somehow make doing nothing feel like a whole vibe. dreamy pixie is soft, calm and quietly curious.' }
};

const QUESTIONS = [
  { type:'cards', q:'Your group chat says: "What are we doing tonight?"', reply:'You reply…', opts:[
    { label:"Lessgooo! I’m already dressed!", persona:'citrus' },
    { label:"Fine, I’ll make the plan. Someone has to.", persona:'mint' },
    { label:'Approved', persona:'daydream' } ] },
  { type:'button', q:'Monday morning. Your alarm goes off. You…', opts:[
    { label:'Nope. Absolutely not.', persona:'citrus' },
    { label:'Hit snooze for 5th time', persona:'mint' },
    { label:'Dream Of No Mondays', persona:'daydream' } ] },
  { type:'portal', q:'You go for a "mental health" walk. What happens?', opts:[
    { label:'It becomes a spontaneous side quest.', persona:'citrus' },
    { label:"I'm texting, scrolling & managing the chaos.", persona:'mint' },
    { label:'I completely zone out and romanticize the walk.', persona:'daydream' } ] }
];

const MARK_SVG = {
  citrus: (s) => `<svg width="${s}" height="${s}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3.1"/><path d="M12 3v5.6M12 15.4V21M3 12h5.6M15.4 12H21M5.7 5.7l3.9 3.9M14.4 14.4l3.9 3.9M18.3 5.7l-3.9 3.9M9.6 14.4l-3.9 3.9"/></svg>`,
  mint: (s) => `<svg width="${s}" height="${s}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.5 3.5c0 9.2-5.7 14-12.2 14H3.5C3.5 8.3 9.2 3.5 15.7 3.5h4.8z"/><path d="M3.5 20.5c3.2-6.4 7.8-10.2 13-12.3"/></svg>`,
  daydream: (s) => `<svg width="${s}" height="${s}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M7.2 19h10.2a3.9 3.9 0 0 0 .4-7.8A6 6 0 0 0 6.6 9.6 4.7 4.7 0 0 0 7.2 19z"/><path d="M2.5 15.5h1.8M19.8 6.4h1.7"/></svg>`
};

const state = {
  persona: null, colour: 'citrus', stage: 'intro', qi: 0,
  answers: [], scores: { citrus:0, mint:0, daydream:0 },
  lock: false, watchHoverPersona: null, footerOpen: {}
};

const $ = (id) => document.getElementById(id);
function on(id, ev, fn){
  const el = $(id);
  if (el) el.addEventListener(ev, fn);
}
function pinQuizToViewport(behavior){
  const quiz = document.getElementById('quiz');
  if (!quiz) return false;
  const html = document.documentElement;
  const body = document.body;
  const prevHtml = html.style.scrollBehavior;
  const prevBody = body ? body.style.scrollBehavior : '';
  html.style.scrollBehavior = 'auto';
  if (body) body.style.scrollBehavior = 'auto';
  const pad = parseFloat(getComputedStyle(html).scrollPaddingTop);
  const offset = Number.isFinite(pad) && pad > 0 ? pad : 64;
  const top = Math.max(0, window.scrollY + quiz.getBoundingClientRect().top - offset);
  const smooth = behavior === 'smooth';
  window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
  const restore = () => {
    html.style.scrollBehavior = prevHtml;
    if (body) body.style.scrollBehavior = prevBody;
  };
  if (smooth) window.setTimeout(restore, 700);
  else restore();
  return true;
}
function afterQuizLayout(fn){
  requestAnimationFrame(() => {
    requestAnimationFrame(fn);
  });
}
function setText(id, text){
  const el = $(id);
  if (el) el.textContent = text;
}
function setHtml(id, html){
  const el = $(id);
  if (el) el.innerHTML = html;
}

function tally(answers){
  const scores = { citrus:0, mint:0, daydream:0 };
  answers.forEach((k) => { if (k in scores) scores[k] += 1; });
  return scores;
}

function resolveWinner(answers){
  const scores = tally(answers);
  const max = Math.max(scores.citrus, scores.mint, scores.daydream);
  const tied = ['citrus','mint','daydream'].filter((k) => scores[k] === max);
  if (tied.length === 1) return tied[0];
  for (let i = answers.length - 1; i >= 0; i--) {
    if (tied.includes(answers[i])) return answers[i];
  }
  return tied[0] || 'citrus';
}

function resetQuiz(){
  state.qi = 0;
  state.lock = false;
  state.answers = [];
  state.scores = { citrus:0, mint:0, daydream:0 };
  state.watchHoverPersona = null;
}

function flash(persona){
  const el = $('flashOverlay');
  if (el) {
    el.style.background = '#fff';
    el.classList.remove('on'); void el.offsetWidth; el.classList.add('on');
    setTimeout(() => el.classList.remove('on'), 500);
  }
  if (persona) {
    const qf = $('quizFlash');
    const p = PERSONAS[persona];
    if (qf && p) {
      qf.style.background = p.color;
      qf.style.opacity = 0.16;
      setTimeout(() => { qf.style.opacity = 0; }, 260);
    }
  }
}

function showPanel(id){
  document.querySelectorAll('.quiz-panel').forEach(p => p.classList.remove('active'));
  const el = $(id);
  if (el) el.classList.add('active');
  if (typeof initHeroMorph._tick === 'function') initHeroMorph._tick();
}

window.addEventListener('resize', () => updateCardScale());

function pixieTrack(id, extra){
  if (!id) return;
  try {
    const triggered = window.HeliumUtils && HeliumUtils.tracking && HeliumUtils.tracking.feature
      && HeliumUtils.tracking.feature.triggered;
    if (typeof triggered === 'function') {
      triggered({ name: 'h_section', id: id }, extra || {});
    }
  } catch (e) {}
}

function bindQuiz(){
  if (window.__pixieQuizBound) return;
  window.__pixieQuizBound = true;
  on('startQuizBtn', 'click', () => {
    pixieTrack('pebble-pixie-quiz-start', { step: 'start' });
    resetQuiz();
    flash();
    setTimeout(() => {
      state.stage = 'quiz';
      showPanel('panelQuiz');
      renderQuestion();
      afterQuizLayout(() => {
        pinQuizToViewport('auto');
        window.setTimeout(() => pinQuizToViewport('auto'), 60);
      });
    }, 240);
  });
  on('backBtn', 'click', () => {
    if (state.qi === 0) { state.stage = 'intro'; showPanel('panelIntro'); return; }
    state.qi = Math.max(0, state.qi - 1);
    state.answers = state.answers.slice(0, state.qi);
    state.scores = tally(state.answers);
    renderQuestion();
  });
  on('retakeBtn', 'click', () => {
    pixieTrack('pebble-pixie-quiz-retake', { step: 'retake', persona: state.persona || undefined });
    resetQuiz();
    state.stage = 'intro';
    showPanel('panelIntro');
  });
  on('downloadBtn', 'click', () => {
    pixieTrack('pebble-pixie-quiz-share', { step: 'share', persona: state.persona || undefined });
    downloadCard();
  });
}

function renderTicks(){
  const wrap = $('ticks');
  if (wrap) {
    wrap.innerHTML = '';
    QUESTIONS.forEach((_, i) => {
      const t = document.createElement('span');
      t.className = 'tick' + (i <= state.qi ? ' done' : '');
      wrap.appendChild(t);
    });
  }
  setText('stepLabel', (Math.min(state.qi + 1, QUESTIONS.length)) + ' / ' + QUESTIONS.length);
}

function renderQuestion(){
  renderTicks();
  const qEl = $('quizQ');
  const body = $('quizBody');
  if (!qEl || !body) return;
  const q = QUESTIONS[Math.min(state.qi, QUESTIONS.length - 1)];
  qEl.textContent = q.q;
  body.innerHTML = '';

  if (q.reply) {
    const reply = document.createElement('p');
    reply.className = 'quiz-reply';
    reply.textContent = q.reply;
    body.appendChild(reply);
  }

  if (q.type === 'cards') {
    const grid = document.createElement('div'); grid.className = 'opt-grid';
    q.opts.forEach((o, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'opt-card'; b.textContent = o.label;
      b.style.animationDelay = (i * 90) + 'ms';
      b.style.setProperty('--accent', PERSONAS[o.persona].color);
      b.onclick = () => advance(o.persona);
      grid.appendChild(b);
    });
    body.appendChild(grid);
  } else if (q.type === 'button') {
    const row = document.createElement('div'); row.className = 'press-pills';
    q.opts.forEach(o => {
      const b = document.createElement('button'); b.type = 'button'; b.className = 'opt-pill'; b.textContent = o.label;
      b.style.setProperty('--accent', PERSONAS[o.persona].color);
      b.onclick = () => advance(o.persona);
      row.appendChild(b);
    });
    body.appendChild(row);
  } else if (q.type === 'portal') {
    const row = document.createElement('div'); row.className = 'portal-row';
    q.opts.forEach(o => {
      const p = PERSONAS[o.persona];
      const b = document.createElement('button'); b.type = 'button'; b.className = 'portal'; b.style.flex = '1'; b.style.background = p.tint;
      b.innerHTML = `<span class="pdot" style="background:${p.color}"></span><span class="pname">${o.label}</span>`;
      b.onmouseenter = () => { row.querySelectorAll('.portal').forEach(x => x.style.flex = x === b ? '2.4' : '0.8'); };
      b.onmouseleave = () => { row.querySelectorAll('.portal').forEach(x => x.style.flex = '1'); };
      b.onclick = () => advance(o.persona);
      row.appendChild(b);
    });
    body.appendChild(row);
  } else if (q.type === 'watch') {
    const row = document.createElement('div'); row.className = 'watch-q-row';
    const img = document.createElement('img'); img.className = 'watch-preview'; img.src = PERSONAS[state.watchHoverPersona || 'citrus'].img;
    row.appendChild(img);
    const opts = document.createElement('div'); opts.className = 'watch-opts';
    q.opts.forEach(o => {
      const b = document.createElement('button'); b.type = 'button'; b.className = 'opt-face'; b.textContent = o.label;
      b.style.setProperty('--accent', PERSONAS[o.persona].color);
      b.onmouseenter = () => { state.watchHoverPersona = o.persona; img.src = PERSONAS[o.persona].img; img.style.transform = `rotate(${o.persona==='citrus'?-8:o.persona==='daydream'?8:0}deg)`; };
      b.onclick = () => advance(o.persona);
      opts.appendChild(b);
    });
    row.appendChild(opts);
    body.appendChild(row);
  }
}

function advance(persona){
  if (state.lock) return;
  if (!PERSONAS[persona]) return;
  state.lock = true;
  flash(persona);
  setTimeout(() => {
    const step = state.qi + 1;
    state.answers[state.qi] = persona;
    state.answers = state.answers.slice(0, state.qi + 1);
    state.qi += 1;
    state.scores = tally(state.answers);
    pixieTrack('pebble-pixie-quiz-q' + step, { step: 'q' + step, persona: persona });
    state.lock = false;
    if (state.qi >= QUESTIONS.length) { runCalculating(); }
    else { renderQuestion(); }
  }, 260);
}

function runCalculating(){
  const win = resolveWinner(state.answers);
  state.persona = win;
  state.colour = win;
  state.scores = tally(state.answers);
  state.stage = 'calculating';
  showPanel('panelCalc');
  afterQuizLayout(() => pinQuizToViewport('auto'));
  const pct = $('calcPct');
  const started = performance.now();
  const duration = 1300;
  const tick = (now) => {
    if (state.stage !== 'calculating') return;
    const progress = Math.min(1, (now - started) / duration);
    const eased = 1 - Math.pow(1 - progress, 3);
    if (pct) pct.textContent = Math.round(eased * 100) + '%';
    if (progress < 1) {
      requestAnimationFrame(tick);
      return;
    }
    window.setTimeout(() => {
      if (state.stage !== 'calculating') return;
      state.stage = 'revealed';
      showPanel('panelReveal');
      renderReveal();
      applyColourway(win);
      pixieTrack('pebble-pixie-quiz-result-' + win, { step: 'result', persona: win });
      afterQuizLayout(() => pinQuizToViewport('auto'));
    }, 180);
  };
  requestAnimationFrame(tick);
}

/* ---- reveal card ---- */
function renderReveal(){
  const p = PERSONAS[state.persona] || PERSONAS.citrus;
  const stage = $('revealStage');
  if (stage) stage.dataset.pixie = p.key;
  const cardBg = $('cardBg');
  if (cardBg) { cardBg.src = p.life; cardBg.alt = p.name + ' polaroid'; }
  setHtml('cardMark', MARK_SVG[p.mark](28));
  const cardMark = $('cardMark'); if (cardMark) cardMark.style.color = p.color;
  setText('cardName', p.name);
  setText('revealVerdict', 'You are ' + p.name + '.');
  setText('cardSubtitle', p.subtitle);
  const linesEl = $('cardLines');
  if (linesEl) linesEl.replaceChildren();

  setText('revealBlurb', p.blurb);

  const chaos = Math.min(96, state.scores.mint * 20 + 12);
  const dream = Math.min(96, state.scores.daydream * 20 + 8);
  const stats = [
    { label:'Boring level', value:2, color:'var(--text-muted)' },
    { label:'Chaos level', value:chaos, color:'var(--color-mint)' },
    { label:'Daydream level', value:dream, color:'var(--color-daydream)' }
  ];
  setHtml('statsRow', stats.map(st => `<div class="stat"><div class="stat-val" style="color:${st.color}">${st.value}%</div><div class="stat-label">${st.label}</div></div>`).join(''));
  updateCardScale();
}

function updateCardScale(){}

function drawMark(x, key, cx, cy, r){
  x.beginPath();
  if (key === 'citrus') {
    x.arc(cx, cy, r, 0, Math.PI*2); x.stroke();
    x.beginPath(); x.arc(cx, cy, r*0.35, 0, Math.PI*2); x.stroke();
    for (let i=0;i<8;i++){ const a=i*Math.PI/4;
      x.beginPath(); x.moveTo(cx+Math.cos(a)*r*0.46, cy+Math.sin(a)*r*0.46); x.lineTo(cx+Math.cos(a)*r*0.92, cy+Math.sin(a)*r*0.92); x.stroke(); }
  } else if (key === 'mint') {
    x.moveTo(cx+r, cy-r);
    x.bezierCurveTo(cx+r, cy+r*0.7, cx-r*0.2, cy+r, cx-r, cy+r);
    x.bezierCurveTo(cx-r, cy-r*0.4, cx+r*0.1, cy-r, cx+r, cy-r);
    x.stroke();
    x.beginPath(); x.moveTo(cx-r, cy+r); x.quadraticCurveTo(cx-r*0.1, cy+r*0.2, cx+r*0.75, cy-r*0.5); x.stroke();
  } else {
    x.arc(cx-r*0.45, cy+r*0.15, r*0.5, Math.PI*0.6, Math.PI*1.9);
    x.arc(cx+r*0.05, cy-r*0.25, r*0.6, Math.PI*1.1, Math.PI*2.05);
    x.arc(cx+r*0.6, cy+r*0.2, r*0.45, Math.PI*1.6, Math.PI*0.5);
    x.closePath(); x.stroke();
  }
}

async function downloadCard(){
  const p = PERSONAS[state.persona] || PERSONAS.citrus;
  const filename = 'pixie-' + p.key + '-avatar.png';
  let blob = null;
  try {
    const response = await fetch(p.life);
    if (response.ok) blob = await response.blob();
  } catch(e){}
  const isAppleMobile = /iPhone|iPad|iPod/i.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (blob && isAppleMobile && navigator.share) {
    const file = new File([blob], filename, { type:'image/png' });
    if (!navigator.canShare || navigator.canShare({ files:[file] })) {
      try {
        await navigator.share({
          title: p.name + ' · Pebble Pixie',
          text: 'Meet my Pebble Pixie avatar.',
          files: [file]
        });
        return;
      } catch (error) {
        if (error && error.name === 'AbortError') return;
      }
    }
  }

  const a = document.createElement('a');
  a.download = filename;
  if (blob) {
    const objectUrl = URL.createObjectURL(blob);
    a.href = objectUrl;
    a.click();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
  } else {
    a.href = p.life;
    a.click();
  }
}

function pixieShareUrl(){
  const key = (state.persona && PERSONAS[state.persona]) ? state.persona : 'citrus';
  const u = new URL(location.href);
  u.searchParams.set('pixie', key);
  u.hash = 'quiz';
  return u.href;
}

async function copyPixieLink(){
  const url = pixieShareUrl();
  const btn = $('copyLinkBtn');
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(url);
    } else {
      const ta = document.createElement('textarea');
      ta.value = url;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      ta.remove();
    }
    if (btn) {
      const prev = btn.getAttribute('data-label') || btn.textContent;
      btn.textContent = 'Copied';
      setTimeout(() => { btn.textContent = prev; }, 1600);
    }
  } catch (e) {
    if (btn) btn.textContent = 'copy failed';
  }
}

function openSharedPixie(){
  const key = new URLSearchParams(location.search).get('pixie');
  if (!key || !PERSONAS[key]) return;
  state.persona = key;
  state.colour = key;
  state.stage = 'revealed';
  showPanel('panelReveal');
  renderReveal();
  applyColourway(key);
}

/* ---- features in motion (sticky stage + scrolling chapters) ---- */
const FEATURE_KEYS = ['display', 'crown', 'health', 'smart'];
let notesUnlocked = 0;
let notesGoingUp = false;
function paintFeatureNotes(count){
  notesUnlocked = count;
  document.querySelectorAll('#features .feature-notes .sticky-note').forEach((el) => {
    const at = Number(el.dataset.noteAt || 99);
    const show = at <= notesUnlocked;
    if (show){
      if (el.classList.contains('is-out-up')){
        el.style.transition = 'none';
        el.classList.remove('is-out-up', 'is-in');
        void el.offsetWidth;
        el.style.transition = '';
      }
      el.classList.add('is-in');
      el.classList.remove('is-out-up');
    } else {
      el.classList.remove('is-in');
      if (notesGoingUp) el.classList.add('is-out-up');
    }
  });
}
function unlockFeatureNotes(key){
  const rank = { display: 1, crown: 2, health: 3, smart: 3 };
  paintFeatureNotes(rank[key] || 0);
}
function setFeature(key, withNotes){
  const reel = $('features');
  if (!reel || !FEATURE_KEYS.includes(key)) return;
  if (reel.dataset.feature !== key){
    reel.dataset.feature = key;
    reel.classList.remove('feature-display', 'feature-crown', 'feature-health', 'feature-smart');
    reel.classList.add('feature-' + key);
    reel.querySelectorAll('.feature-stage > .feature-stage-layer').forEach((el) => {
      el.classList.toggle('active', el.dataset.layer === key);
    });
    const idx = $('featureIdx');
    if (idx) idx.textContent = String(FEATURE_KEYS.indexOf(key) + 1).padStart(2, '0');
  }
  syncFeatureVids(key);
  if (withNotes !== false) unlockFeatureNotes(key);
}
function syncFeatureVids(beat){
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const map = {
    display: '[data-dome-vid]',
    crown: '[data-haptic-vid]',
    health: '[data-health-vid]',
    smart: '[data-smart-vid]'
  };
  document.querySelectorAll('[data-dome-vid], [data-haptic-vid], [data-health-vid], [data-smart-vid]').forEach((v) => {
    const host = v.closest('.feature-stage, .feature-chapter-visual');
    const shown = host && host.offsetParent;
    const sel = map[beat];
    const should = !reduced && shown && sel && v.matches(sel);
    if (should) v.play().catch(() => {});
    else v.pause();
  });
}
function sizeFeatureNotesBound(){
  const bound = $('featureNotesBound');
  const pin = document.querySelector('#features .feature-notes-pin');
  if (pin) pin.removeAttribute('style');
  if (!bound) return;
  if (window.matchMedia('(max-width: 720px)').matches){
    bound.style.height = '';
    return;
  }
  const layout = document.querySelector('.feature-reel-layout');
  const last = document.querySelector('[data-feature-chapter="smart"]') || document.querySelector('[data-feature-chapter="health"]');
  if (!layout || !last) return;
  const top = layout.getBoundingClientRect().top;
  const end = last.getBoundingClientRect().bottom;
  bound.style.height = Math.max(0, Math.round(end - top)) + 'px';
}
function featurePinLine(){
  const stage = document.querySelector('#features .feature-stage');
  if (stage && getComputedStyle(stage).display !== 'none'){
    const r = stage.getBoundingClientRect();
    if (r.height > 40) return r.top + r.height * 0.38;
  }
  return (window.innerHeight || 800) * 0.38;
}
function activeFeatureFromScroll(chapterEls){
  const line = featurePinLine();
  let key = null;
  for (let i = 0; i < chapterEls.length; i++){
    const ch = chapterEls[i];
    if (ch.getBoundingClientRect().top <= line) key = ch.dataset.featureChapter || key;
  }
  return key;
}
function syncFeatureFromScroll(chapterEls){
  const key = activeFeatureFromScroll(chapterEls);
  const rank = { display: 1, crown: 2, health: 3, smart: 3 };
  const next = key ? (rank[key] || 0) : 0;
  notesGoingUp = next < notesUnlocked;
  if (!key){
    paintFeatureNotes(0);
    setFeature('display', false);
    return;
  }
  setFeature(key);
}
function initDomeSequence(){
  const reel = $('features');
  const chapter = document.querySelector('[data-feature-chapter="display"]');
  const targets = Array.from(document.querySelectorAll('[data-dome-sequence]'));
  if (!reel || !chapter || !targets.length) return;

  const seed = targets[0].currentSrc || targets[0].src;
  const urls = Array.from({ length: 50 }, (_, index) => {
    const frame = String(index + 1).padStart(3, '0');
    return seed.replace(/pixie-dial-frame-\d{3}\.jpg/, 'pixie-dial-frame-' + frame + '.jpg');
  });
  const frames = urls.map((url) => {
    const image = new Image();
    image.decoding = 'async';
    image.src = url;
    return image;
  });
  const framesReady = Promise.all(frames.map((image) => {
    if (image.complete) return Promise.resolve();
    return new Promise((resolve) => {
      image.addEventListener('load', resolve, { once: true });
      image.addEventListener('error', resolve, { once: true });
    });
  }));
  let currentFrame = 49;
  let playToken = 0;
  let isOn = false;
  let ticking = false;

  const paint = (index) => {
    if (index === currentFrame) return;
    targets.forEach((target) => {
      if (target.src !== urls[index]) target.src = urls[index];
    });
    currentFrame = index;
  };

  const animateTo = (targetFrame) => {
    const token = ++playToken;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      paint(targetFrame);
      return;
    }
    framesReady.then(() => {
      if (token !== playToken) return;
      const startFrame = currentFrame;
      const distance = targetFrame - startFrame;
      if (!distance) return;
      const started = performance.now();
      const duration = Math.max(260, 950 * Math.abs(distance) / 49);
      const animate = (now) => {
        if (token !== playToken) return;
        const progress = Math.min(1, (now - started) / duration);
        paint(Math.round(startFrame + distance * progress));
        if (progress < 1) requestAnimationFrame(animate);
      };
      requestAnimationFrame(animate);
    });
  };

  const watchNode = () => {
    const stage = reel.querySelector('.feature-stage');
    const chapterVisual = chapter.querySelector('.feature-chapter-visual');
    if (stage && getComputedStyle(stage).display !== 'none') return stage;
    return chapterVisual || targets[0];
  };

  const shouldTurnOn = () => {
    const node = watchNode();
    if (!node) return false;
    const rect = node.getBoundingClientRect();
    const mid = window.innerHeight * 0.5;
    return rect.top <= mid && rect.bottom > window.innerHeight * 0.18;
  };

  const syncWatch = () => {
    ticking = false;
    const nextOn = shouldTurnOn();
    if (nextOn === isOn) return;
    isOn = nextOn;
    animateTo(nextOn ? 0 : 49);
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(syncWatch);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  syncWatch();
}
function initFeatureReel(){
  const reel = $('features');
  const chapters = Array.from(document.querySelectorAll('[data-feature-chapter]'));
  if (!reel || !chapters.length) return;
  setFeature('display', false);
  sizeFeatureNotesBound();
  window.addEventListener('resize', sizeFeatureNotesBound);
  window.addEventListener('scroll', () => {
    syncFeatureFromScroll(chapters);
  }, { passive: true });
  if ('ResizeObserver' in window){
    const ro = new ResizeObserver(sizeFeatureNotesBound);
    ro.observe(reel);
    const last = document.querySelector('[data-feature-chapter="smart"]') || document.querySelector('[data-feature-chapter="health"]');
    if (last) ro.observe(last);
  }
  const onPin = () => {
    syncFeatureFromScroll(chapters);
  };
  if (!('IntersectionObserver' in window)){
    onPin();
    return;
  }
  const obs = new IntersectionObserver(onPin, {
    rootMargin: '-36% 0px -48% 0px',
    threshold: [0, 0.08, 0.2, 0.4, 0.6, 0.8, 1]
  });
  chapters.forEach((ch) => obs.observe(ch));
  obs.observe(reel);
  onPin();
}

/* ---- swatch selector ---- */
function paintSwatchRow(row, size, selectedBorder){
  if (!row) return;
  const isPersonas = row.id === 'swatchRow';
  row.innerHTML = '';
  ['citrus','mint','daydream'].forEach(key => {
    const p = PERSONAS[key];
    const selected = state.colour === key;
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'swatch-dot' + (selected ? ' is-selected' : '');
    b.setAttribute('aria-label', p.name);
    b.setAttribute('aria-pressed', selected ? 'true' : 'false');
    b.style.background = p.color;
    if (!isPersonas) {
      b.style.width = size;
      b.style.height = size;
      b.style.borderRadius = '50%';
      b.style.cursor = 'pointer';
      b.style.border = selected ? selectedBorder : '3px solid transparent';
    }
    b.onclick = () => applyColourway(key);
    row.appendChild(b);
  });
}
function applyColourway(key){
  if (!PERSONAS[key]) return;
  state.colour = key;
  const footer = $('siteFooter');
  if (footer) footer.dataset.pixie = key;
  const club = $('club');
  if (club) club.dataset.pixie = key;
  const personas = $('personas');
  if (personas) personas.dataset.pixie = key;
  setText('clubChip', PERSONAS[key].name);
  renderSwatches();
  renderSwatchDisplay();
}
function renderSwatches(){
  paintSwatchRow($('swatchRow'), '44px', '3px solid var(--color-ink)');
  paintSwatchRow($('footerSwatches'), '22px', '3px solid var(--color-white)');
}
function renderSwatchDisplay(){
  const p = PERSONAS[state.colour] || PERSONAS.citrus;
  setHtml('swatchMark', MARK_SVG[p.key](34));
  const mark = $('swatchMark'); if (mark) mark.style.color = p.color;
  setText('swatchName', p.name);
  const img = $('swatchImg'); if (img) img.src = p.img;
  const atc = $('personasAtc');
  if (atc){
    delete atc.dataset.added;
    const vid = pixieVariantId(p.key);
    if (vid) atc.setAttribute('data-variant-id', vid);
    else atc.removeAttribute('data-variant-id');
    const routes = pixieRoutes();
    const base = (routes.productUrls && routes.productUrls[p.key]) || '/products/pebble-pixie';
    atc.setAttribute('href', vid ? (base + (base.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + vid) : base);
  }
}

/* ---- footer accordion (mobile) ---- */
const FOOTER_COLS = [
  { title:'Quick links', links:[
    { label:'New launches', href:'#hero' },
    { label:'Pixie smartwatch', href:'#features' },
    { label:'Straps & bands', href:'#straps' },
    { label:'Accessories', href:'#faces' }
  ]},
  { title:'Company', links:[
    { label:'About us', href:'#club' },
    { label:'Careers', href:'#club' },
    { label:'Press', href:'#club' },
    { label:'Contact', href:'mailto:hello@pebble.com' }
  ]},
  { title:'Support', links:[
    { label:'FAQs', href:'#features' },
    { label:'Warranty policy', href:'#club' },
    { label:'Track your order', href:'#club' },
    { label:'Shipping & returns', href:'#club' }
  ]}
];
function renderFooter(){
  const wrap = $('footerCols');
  if (!wrap || wrap.dataset.static === '1') return;
  wrap.innerHTML = '';
  FOOTER_COLS.forEach(col => {
    const box = document.createElement('div');
    box.innerHTML = `
      <button class="footer-toggle" data-col="${col.title}">
        <span class="footer-col-title">${col.title}</span>
        <span class="chev" style="transform:rotate(${state.footerOpen[col.title] ? 180 : 0}deg);transition:transform 380ms">▾</span>
      </button>
      <div class="footer-links${state.footerOpen[col.title] ? ' open' : ''}">
        ${col.links.map(l => `<a href="${l.href}">${l.label}</a>`).join('')}
      </div>`;
    box.querySelector('.footer-toggle').onclick = () => {
      state.footerOpen[col.title] = !state.footerOpen[col.title];
      renderFooter();
    };
    wrap.appendChild(box);
  });
}

/* ---- watchface showcase (native stills from standalone, no compressed mp4) ---- */
const FACE_STILLS = A.faces || [];
function fillFaceRow(row){
  if (!row) return;
  const loop = FACE_STILLS.concat(FACE_STILLS);
  row.innerHTML = loop.map((src) => '<span><img src="' + src + '" alt=""></span>').join('');
}
function initFacesShowcase(){
  const media = $('facesMedia');
  const row = $('facesRow');
  const inner = $('facesRowInner');
  if (!media || !row || !inner) return;
  fillFaceRow(row);
  fillFaceRow(inner);
  const rows = [row, inner];
  const W = 1920;
  const boxSize = 690;
  const diam = 0.527 * boxSize;
  const gap = diam * 0.32;
  const pitch = diam + gap;
  const stripWidth = pitch * FACE_STILLS.length;
  const speed = stripWidth / 11.6;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fit = () => {
    const w = media.clientWidth;
    const h = media.clientHeight;
    const s = w < 721
      ? (w * 0.7) / 690
      : Math.max(w / 1920, h / 1080);
    media.style.setProperty('--faces-scale', String(s));
  };
  fit();
  window.addEventListener('resize', fit, { passive: true });
  let playing = false, origin = 0, held = 0, raf = 0;
  const apply = (T) => {
    const raw = ((T * speed) % stripWidth + stripWidth) % stripWidth;
    const x = W / 2 - raw;
    rows.forEach((el) => { el.style.transform = 'translate3d(' + x + 'px,0,0)'; });
  };
  const tick = (now) => {
    if (!playing) return;
    apply(held + (now - origin) / 1000);
    raf = requestAnimationFrame(tick);
  };
  const play = () => {
    if (reduced || playing) return;
    playing = true;
    origin = performance.now();
    raf = requestAnimationFrame(tick);
  };
  const pause = () => {
    if (!playing) return;
    playing = false;
    held += (performance.now() - origin) / 1000;
    if (raf) cancelAnimationFrame(raf);
  };
  apply(0);
  if (reduced) return;
  if (!('IntersectionObserver' in window)){ play(); return; }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { e.isIntersecting ? play() : pause(); });
  }, { threshold: 0.2 });
  io.observe(media);
}

/* ---- hero intro → plate ---- */
function showHeroPlate(){
  const hero = $('hero');
  if (!hero) return;
  hero.classList.remove('is-intro');
  hero.classList.add('is-plate');
  const intro = $('heroIntro');
  if (intro) intro.setAttribute('aria-hidden', 'true');
  if (intro) intro.removeAttribute('tabindex');
  if (typeof initHeroMorph._tick === 'function') initHeroMorph._tick();
}
function initHeroIntro(){
  const hero = $('hero');
  const intro = $('heroIntro');
  if (!hero) return;
  const skip = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    || (location.hash && location.hash !== '#hero' && location.hash !== '#top');
  if (skip){
    showHeroPlate();
    return;
  }
  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    showHeroPlate();
  };
  window.setTimeout(finish, 2800);
  if (intro){
    intro.addEventListener('click', finish);
    intro.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); finish(); }
    });
  }
}

/* ---- hero image morphs into quiz intro ---- */
function initHeroMorph(){
  const hero = $('hero');
  const src = $('heroRender') || document.querySelector('#hero .hero-render');
  const slot = $('quizHeroSlot');
  const quiz = $('quiz');
  const intro = $('panelIntro');
  if (!hero || !src || !slot || !quiz) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced){
    slot.classList.add('is-filled');
    return;
  }

  const fly = src.cloneNode(true);
  fly.id = 'heroFly';
  fly.className = 'hero-fly';
  fly.removeAttribute('fetchpriority');
  fly.removeAttribute('id');
  fly.id = 'heroFly';
  fly.alt = '';
  fly.loading = 'eager';
  document.body.appendChild(fly);

  let raf = 0;
  let landed = false;
  const lerp = (a, b, t) => a + (b - a) * t;
  const clamp01 = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);
  const ease = (t) => 1 - Math.pow(1 - t, 3);

  const tick = () => {
    raf = 0;
    const introOn = intro && intro.classList.contains('active');
    const plated = hero.classList.contains('is-plate');
    if (!introOn || !plated){
      fly.classList.remove('is-on');
      hero.classList.remove('is-morphing');
      slot.classList.remove('is-filled');
      hero.style.removeProperty('--hero-copy-fade');
      landed = false;
      return;
    }

    const quizTop = quiz.getBoundingClientRect().top;
    const vh = window.innerHeight || 1;
    const p = clamp01(1 - quizTop / vh);
    hero.style.setProperty('--hero-copy-fade', String(Math.max(0, 1 - p * 1.45)));

    if (p <= 0.012){
      fly.classList.remove('is-on');
      hero.classList.remove('is-morphing');
      slot.classList.remove('is-filled');
      landed = false;
      return;
    }

    if (landed){
      if (p < 0.78) landed = false;
    } else if (p >= 0.86){
      landed = true;
    }

    if (landed){
      fly.classList.remove('is-on');
      hero.classList.add('is-morphing');
      slot.classList.add('is-filled');
      return;
    }

    const start = src.getBoundingClientRect();
    const end = slot.getBoundingClientRect();
    if (start.width < 8 || end.width < 8) return;

    slot.classList.remove('is-filled');
    hero.classList.add('is-morphing');
    fly.classList.add('is-on');

    const e = ease(p);
    const mobile = window.matchMedia('(max-width: 720px)').matches;
    const popIn = (!mobile && p < 0.28) ? 1 + 0.22 * Math.sin((p / 0.28) * Math.PI) : 1;
    const landT = p > 0.62 ? (p - 0.62) / 0.24 : 0;
    const popOut = (!mobile && landT > 0) ? 1 + 0.16 * Math.sin(Math.min(landT, 1) * Math.PI) : 1;
    const scale = (lerp(start.width, end.width, e) / start.width) * popIn * popOut;
    const startCx = start.left + start.width * 0.5;
    const startCy = start.top + start.height * 0.5;
    const endCx = end.left + end.width * 0.5;
    const endCy = end.top + end.height * 0.5;
    const cx = mobile ? startCx : lerp(startCx, endCx, e);
    const cy = lerp(startCy, endCy, e);
    fly.style.width = start.width + 'px';
    fly.style.height = start.height + 'px';
    fly.style.transform = 'translate(' + (cx - start.width * 0.5) + 'px,' + (cy - start.height * 0.5) + 'px) scale(' + scale + ')';
  };

  const requestTick = () => {
    if (raf) return;
    raf = requestAnimationFrame(tick);
  };
  initHeroMorph._tick = requestTick;

  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick, { passive: true });
  requestTick();
}

function initFilmMarquee(){
  const viewport = document.querySelector('.pixie-page .quiz-film-viewport');
  const track = document.querySelector('.pixie-page .quiz-film-track');
  if (!viewport || !track) return;
  const seed = track.querySelector('.quiz-film-run');
  if (!seed || !seed.children.length) return;

  track.querySelectorAll('img').forEach((img) => {
    img.loading = 'eager';
    img.decoding = 'async';
  });

  const PX_PER_SEC = 46;
  const originals = [...seed.children].filter((n) => !n.hasAttribute('data-film-extra'));
  let resizeTimer = 0;

  const fill = () => {
    const viewW = viewport.getBoundingClientRect().width;
    if (viewW < 8 || !originals.length) return;

    track.querySelectorAll('[data-film-clone]').forEach((n) => n.remove());
    seed.querySelectorAll('[data-film-extra]').forEach((n) => n.remove());
    let guard = 0;
    while (seed.getBoundingClientRect().width < viewW + 8 && guard++ < 16) {
      originals.forEach((node) => {
        const clone = node.cloneNode(true);
        clone.removeAttribute('id');
        clone.setAttribute('data-film-extra', '');
        seed.appendChild(clone);
      });
    }

    const runW = seed.getBoundingClientRect().width;
    const html = seed.innerHTML;
    let runs = [...track.querySelectorAll('.quiz-film-run')];
    if (runs.length === 1) {
      const copy = seed.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('data-film-clone', '');
      track.appendChild(copy);
      runs = [...track.querySelectorAll('.quiz-film-run')];
    }
    runs.slice(1).forEach((run) => {
      run.innerHTML = html;
      run.setAttribute('aria-hidden', 'true');
    });

    let total = runW * track.querySelectorAll('.quiz-film-run').length;
    while (total < viewW * 3) {
      const copy = seed.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('data-film-clone', '');
      track.appendChild(copy);
      total += runW;
    }

    track.style.setProperty('--film-shift', runW + 'px');
    track.style.setProperty('--film-duration', Math.max(18, runW / PX_PER_SEC) + 's');
    track.classList.add('is-looping');
  };

  const schedule = () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(fill, 80);
  };

  fill();
  Promise.all([...seed.querySelectorAll('img')].map((img) => {
    if (img.complete) return Promise.resolve();
    return new Promise((resolve) => {
      img.addEventListener('load', resolve, { once: true });
      img.addEventListener('error', resolve, { once: true });
    });
  })).then(fill);

  window.addEventListener('resize', schedule, { passive: true });
}

/* ---- init ---- */
try { initHeroIntro(); } catch (e) {}
try { initHeroMorph(); } catch (e) {}
try { initDomeSequence(); } catch (e) {}
try { initFeatureReel(); } catch (e) {}
try { initFilmMarquee(); } catch (e) {}
try { applyColourway(state.colour); } catch (e) {}
try { openSharedPixie(); } catch (e) {}
try { renderFooter(); } catch (e) {}
try { initFacesShowcase(); } catch (e) {}
try {
  document.querySelectorAll('#footerCols[data-static="1"] .footer-toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      const links = btn.nextElementSibling;
      if (!links) return;
      const open = links.classList.toggle('open');
      const chev = btn.querySelector('.chev');
      if (chev) chev.style.transform = 'rotate(' + (open ? 180 : 0) + 'deg)';
    });
  });
} catch (e) {}
function pixieRoutes(){
  return window.PIXIE_ROUTES || {};
}
function pixieRoot(){
  const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  return root || '/';
}
function pixieCartAddUrl(){
  const add = pixieRoutes().cartAdd || (pixieRoot() + 'cart/add');
  if (/\.js(\?|$)/.test(add)) return add;
  return add.replace(/\/?(\?|$)/, '.js$1');
}
function pixieVariantId(key){
  const routes = pixieRoutes();
  const mapped = routes.variants && routes.variants[key];
  if (mapped) return mapped;
  const btn = $('personasAtc');
  return (btn && btn.getAttribute('data-variant-id')) || null;
}
function pixieBindNativeCartDrawer(drawer){
  if (!drawer || drawer._pixiePortalBound || !document.body.classList.contains('tem-pebble-pixie')) return;
  const home = drawer.parentNode;
  const marker = document.createComment('pixie-cart-drawer-home');
  home.insertBefore(marker, drawer);
  const portal = () => {
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
  };
  const restore = () => {
    window.setTimeout(() => {
      const details = drawer.querySelector('details');
      if (details && details.open) return;
      if (marker.parentNode && drawer.parentNode !== marker.parentNode) {
        marker.parentNode.insertBefore(drawer, marker.nextSibling);
      }
    }, 450);
  };
  const summary = drawer.querySelector('.cart-drawer-container > summary');
  if (summary) summary.addEventListener('click', portal, { capture: true });
  drawer.addEventListener('close', restore);
  drawer._pixiePortal = portal;
  drawer._pixiePortalBound = true;
}
function pixieCartDrawer(){
  const drawer = document.querySelector('cart-drawer');
  const usesNativeHeader = document.body.classList.contains('tem-pebble-pixie');
  if (drawer && drawer.closest('#shopify-section-header')) {
    if (usesNativeHeader) {
      pixieBindNativeCartDrawer(drawer);
      drawer._pixiePortal();
    } else {
      document.body.appendChild(drawer);
    }
  }
  return drawer;
}
function pixieMiniCart(){
  const drawer = pixieCartDrawer();
  return (drawer && drawer.querySelector('mini-cart')) || document.querySelector('mini-cart');
}
function pixieOpenCart(){
  const miniCart = pixieMiniCart();
  if (miniCart && typeof miniCart.open === 'function') {
    miniCart.open();
    return true;
  }
  const drawer = pixieCartDrawer();
  if (drawer && typeof drawer.open === 'function') {
    drawer.open();
    return true;
  }
  const summary = drawer
    ? drawer.querySelector('.cart-drawer-container > summary')
    : document.querySelector('.cart-drawer-container > summary, #shopify-section-header summary.header__icon--cart');
  if (drawer && summary && typeof drawer.openMenuDrawer === 'function') {
    const details = summary.closest('details');
    if (details) details.setAttribute('open', '');
    drawer.openMenuDrawer(summary);
    return true;
  }
  if (summary) {
    summary.click();
    return true;
  }
  window.location.href = pixieRoot() + 'cart';
  return false;
}
function pixieUpdateCartCount(count){
  const el = $('pixieCartCount');
  if (!el) return;
  const n = Number(count) || 0;
  el.textContent = String(n);
  el.hidden = n < 1;
}
function pixieRefreshCartCount(){
  fetch(pixieRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } })
    .then((res) => res.json())
    .then((cart) => pixieUpdateCartCount(cart && cart.item_count))
    .catch(() => {});
}
function pixieMatchVariant(product, key){
  const variants = (product && product.variants) || [];
  const needles = {
    citrus: ['citrus', 'spark', 'orange'],
    mint: ['mint', 'mischief', 'green'],
    daydream: ['daydream', 'dreamy', 'blue']
  }[key] || [];
  const found = variants.find((v) => {
    const hay = [v.title, v.option1, v.option2, v.option3].filter(Boolean).join(' ').toLowerCase();
    return needles.some((n) => hay.indexOf(n) !== -1);
  });
  if (found) return found.id;
  return variants[0] ? variants[0].id : null;
}
function pixieResolveVariant(key){
  const known = pixieVariantId(key);
  if (known) return Promise.resolve(Number(known));
  const routes = pixieRoutes();
  if (routes._resolving) return routes._resolving.then(() => {
    const id = pixieVariantId(key);
    return id ? Number(id) : null;
  });
  const handles = (routes.handles && routes.handles.length)
    ? routes.handles
    : ['pebble-pixie', 'pixie', 'pixie-smartwatch', 'pebble-pixie-smartwatch'];
  routes._resolving = (async () => {
    for (let i = 0; i < handles.length; i++) {
      try {
        const res = await fetch(pixieRoot() + 'products/' + handles[i] + '.js');
        if (!res.ok) continue;
        const product = await res.json();
        routes.variants = routes.variants || {};
        routes.productUrls = routes.productUrls || {};
        ['citrus', 'mint', 'daydream'].forEach((k) => {
          if (!routes.variants[k]) routes.variants[k] = pixieMatchVariant(product, k);
          if (!routes.productUrls[k]) routes.productUrls[k] = product.url;
        });
        window.PIXIE_ROUTES = routes;
        return;
      } catch (e) {}
    }
  })();
  return routes._resolving.then(() => {
    const id = pixieVariantId(key);
    return id ? Number(id) : null;
  });
}
function pixieAddToCart(variantId){
  const miniCart = pixieMiniCart();
  const sections = (miniCart && typeof miniCart.getSectionsToRender === 'function')
    ? miniCart.getSectionsToRender().map((s) => s.id)
    : ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
  const item = { id: Number(variantId), quantity: 1 };
  return fetch(pixieCartAddUrl(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      items: [item],
      sections: sections.join(','),
      sections_url: window.location.pathname
    })
  }).then((res) => res.json().then((data) => ({ ok: res.ok, data }))).then(({ ok, data }) => {
    if (!ok) {
      throw new Error((data && (data.description || data.message)) || 'Unable to add this item');
    }
    if (data && data.status && (data.message || data.description)) {
      throw new Error(data.description || data.message);
    }
    if (miniCart && typeof miniCart.renderContents === 'function' && data && data.sections) {
      miniCart.renderContents(data);
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data } }));
    if (typeof window.triggerCartUpdate === 'function') window.triggerCartUpdate();
    pixieOpenCart();
    const cart = data && (data.cart || data);
    if (cart && typeof cart.item_count !== 'undefined') pixieUpdateCartCount(cart.item_count);
    else pixieRefreshCartCount();
    return data;
  });
}

bindQuiz();
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-pixie-atc]');
  if (!btn || btn.dataset.busy) return;
  e.preventDefault();
  const p = PERSONAS[state.colour] || PERSONAS.citrus;
  const label = btn.querySelector('#personasAtcLabel');
  const originalLabel = label ? label.textContent : btn.textContent;
  const setLabel = (text) => {
    if (label) label.textContent = text;
    else btn.textContent = text;
  };
  btn.dataset.busy = '1';
  btn.setAttribute('aria-disabled', 'true');
  if ('disabled' in btn) btn.disabled = true;
  setLabel('Adding…');
  pixieResolveVariant(p.key).then((variantId) => {
    if (!variantId) {
      throw new Error('Pixie product is not assigned');
    }
    return pixieAddToCart(variantId).then(() => {
      setLabel('Added to cart');
    });
  }).catch((error) => {
    console.error('Pixie add to cart:', error);
    setLabel('Product unavailable');
  }).finally(() => {
    window.setTimeout(() => {
      delete btn.dataset.busy;
      btn.removeAttribute('aria-disabled');
      if ('disabled' in btn) btn.disabled = false;
      setLabel(originalLabel);
    }, 1600);
  });
});
on('pixieCartBtn', 'click', (e) => {
  e.preventDefault();
  pixieOpenCart();
});
try {
  const nativeDrawer = document.querySelector('cart-drawer');
  pixieBindNativeCartDrawer(nativeDrawer);
} catch (e) {}
try { pixieRefreshCartCount(); } catch (e) {}
on('logoBtn', 'click', () => {
  const url = location.pathname + location.search;
  if (location.hash) history.replaceState(null, '', url);
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

document.addEventListener('click', (e) => {
  const heroColor = e.target.closest('[data-hero-color]');
  if (heroColor) {
    const hero = heroColor.closest('#hero');
    if (!hero) return;
    const colors = {
      citrus: '#f0921f',
      mint: '#7dc496',
      daydream: '#93c4d6'
    };
    const key = heroColor.dataset.heroColor;
    if (!colors[key]) return;
    hero.style.setProperty('--hero-accent', colors[key]);
    hero.querySelectorAll('[data-hero-color]').forEach((option) => {
      const active = option === heroColor;
      option.classList.toggle('is-active', active);
      option.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    return;
  }

  const strapColor = e.target.closest('[data-strap-src]');
  if (strapColor) {
    const straps = strapColor.closest('#straps');
    const image = straps && straps.querySelector('[data-strap-visual] img');
    if (!straps || !image) return;
    const key = strapColor.dataset.strapColor;
    const styles = getComputedStyle(straps.closest('.pixie-page') || straps);
    const colors = {
      citrus: styles.getPropertyValue('--color-citrus').trim(),
      mint: styles.getPropertyValue('--color-mint').trim(),
      daydream: styles.getPropertyValue('--color-daydream').trim()
    };
    if (!colors[key]) return;
    straps.dataset.strapColor = key;
    straps.style.backgroundColor = colors[key];
    image.style.opacity = '0';
    window.setTimeout(() => {
      image.src = strapColor.dataset.strapSrc;
      image.removeAttribute('srcset');
      image.alt = strapColor.getAttribute('aria-label') || 'Pixie watch';
      image.style.opacity = '1';
    }, 140);
    straps.querySelectorAll('[data-strap-src]').forEach((option) => {
      const active = option === strapColor;
      option.classList.toggle('is-active', active);
      option.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    return;
  }

  const btn = e.target.closest('[data-lifestyle-color]');
  if (!btn) return;
  const section = btn.closest('#lifestyle');
  const watch = section && section.querySelector('[data-lifestyle-watch] img');
  if (!section || !watch) return;
  const key = btn.dataset.lifestyleColor;
  const galleryImages = [1, 2, 3, 4]
    .map((index) => section.querySelector('#lifestyleImage' + index))
    .filter(Boolean);
  section.querySelectorAll('[data-lifestyle-color]').forEach((option) => {
    const active = option === btn;
    option.classList.toggle('active', active);
    option.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
  const bento = section.querySelector('.lifestyle-bento');
  if (bento) bento.dataset.lifestyleTheme = key;
  [...galleryImages, watch].forEach((image) => { image.style.opacity = '0'; });
  window.setTimeout(() => {
    galleryImages.forEach((image, index) => {
      const src = btn.getAttribute('data-image-' + (index + 1));
      if (src) image.src = src;
      image.removeAttribute('srcset');
      image.alt = btn.textContent.trim() + ' campaign image ' + (index + 1);
      image.style.opacity = '1';
    });
    watch.src = btn.dataset.watchSrc;
    watch.removeAttribute('srcset');
    watch.alt = btn.textContent.trim() + ' Pixie watch';
    watch.style.opacity = '1';
  }, 140);
});

function pixieScrollToId(id){
  if (!id) return false;
  if (id === 'quiz') return pinQuizToViewport('smooth');
  const el = document.getElementById(id) || (id === 'atc' ? $('personas') : null);
  if (!el) return false;
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return true;
}
document.addEventListener('click', (e) => {
  const a = e.target.closest('a[data-pixie-scroll], a.hero-cta');
  if (!a) return;
  const attr = a.getAttribute('data-pixie-scroll');
  const href = a.getAttribute('href') || '';
  let id = attr || '';
  if (!id && href.charAt(0) === '#') id = href.slice(1);
  if (!id){
    try {
      const u = new URL(href, location.href);
      if (u.hash) id = u.hash.slice(1);
    } catch (err) {}
  }
  if (pixieScrollToId(id)) e.preventDefault();
});

})();


// (function(){
// const A = window.PIXIE_ASSETS || {};
// const PERSONAS = {
//   citrus: { key:'citrus', mark:'citrus', name:'Citrus spark', type:'01', color:'#f0921f', tint:'#ffeeda',
//     subtitle:'bold, spontaneous, always ready for the next adventure.', line1:"You don't wait for the fun.", line2:'You bring it.',
//     img:A.wCitrus, photo:A.cardCitrus, life:A.cardCitrus, vibe:'Bold · social · spontaneous',
//     blurb:"sitting still? not really your thing. citrus spark is bold, social and always ready for the next adventure." },
//   mint: { key:'mint', mark:'mint', name:'Mint mischief', type:'02', color:'#7dc496', tint:'#eaf7ee',
//     subtitle:'sweet on the outside, slightly chaotic underneath.', line1:'You have a plan.', line2:'Whether anyone follows it is another story.',
//     img:A.wMint, photo:A.cardMint, life:A.cardMint, vibe:'Playful · clever · chaotic',
//     blurb:'probably the unofficial planner, problem-solver and chaos manager of your friend group. mint mischief keeps the group chat unwell in the best possible way.' },
//   daydream: { key:'daydream', mark:'daydream', name:'Dreamy pixie', type:'03', color:'#93c4d6', tint:'#e8f4f8',
//     subtitle:'soft, curious, and happily lost in your own little world.', line1:'Life is better when you slow down.', line2:'And notice the little things.',
//     img:A.wBlue, photo:A.cardDaydream, life:A.cardDaydream, vibe:'Dreamy · calm · curious',
//     blurb:'you romanticize ordinary moments and somehow make doing nothing feel like a whole vibe. dreamy pixie is soft, calm and quietly curious.' }
// };

// const QUESTIONS = [
//   { type:'cards', q:'Your group chat says: "What are we doing tonight?"', reply:'You reply…', opts:[
//     { label:"Lessgooo! I’m already dressed!", persona:'citrus' },
//     { label:"Fine, I’ll make the plan. Someone has to.", persona:'mint' },
//     { label:'Approved', persona:'daydream' } ] },
//   { type:'button', q:'Monday morning. Your alarm goes off. You…', opts:[
//     { label:'Nope. Absolutely not.', persona:'citrus' },
//     { label:'Hit snooze for 5th time', persona:'mint' },
//     { label:'Dream Of No Mondays', persona:'daydream' } ] },
//   { type:'portal', q:'You go for a "mental health" walk. What happens?', opts:[
//     { label:'It becomes a spontaneous side quest.', persona:'citrus' },
//     { label:"I'm texting, scrolling & managing the chaos.", persona:'mint' },
//     { label:'I completely zone out and romanticize the walk.', persona:'daydream' } ] }
// ];

// const MARK_SVG = {
//   citrus: (s) => `<svg width="${s}" height="${s}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3.1"/><path d="M12 3v5.6M12 15.4V21M3 12h5.6M15.4 12H21M5.7 5.7l3.9 3.9M14.4 14.4l3.9 3.9M18.3 5.7l-3.9 3.9M9.6 14.4l-3.9 3.9"/></svg>`,
//   mint: (s) => `<svg width="${s}" height="${s}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.5 3.5c0 9.2-5.7 14-12.2 14H3.5C3.5 8.3 9.2 3.5 15.7 3.5h4.8z"/><path d="M3.5 20.5c3.2-6.4 7.8-10.2 13-12.3"/></svg>`,
//   daydream: (s) => `<svg width="${s}" height="${s}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M7.2 19h10.2a3.9 3.9 0 0 0 .4-7.8A6 6 0 0 0 6.6 9.6 4.7 4.7 0 0 0 7.2 19z"/><path d="M2.5 15.5h1.8M19.8 6.4h1.7"/></svg>`
// };

// const state = {
//   persona: null, colour: 'citrus', stage: 'intro', qi: 0,
//   answers: [], scores: { citrus:0, mint:0, daydream:0 },
//   lock: false, watchHoverPersona: null, footerOpen: {}
// };

// const $ = (id) => document.getElementById(id);
// function on(id, ev, fn){
//   const el = $(id);
//   if (el) el.addEventListener(ev, fn);
// }
// function pinQuizToViewport(behavior){
//   const quiz = document.getElementById('quiz');
//   if (!quiz) return false;
//   const html = document.documentElement;
//   const body = document.body;
//   const prevHtml = html.style.scrollBehavior;
//   const prevBody = body ? body.style.scrollBehavior : '';
//   html.style.scrollBehavior = 'auto';
//   if (body) body.style.scrollBehavior = 'auto';
//   const pad = parseFloat(getComputedStyle(html).scrollPaddingTop);
//   const offset = Number.isFinite(pad) && pad > 0 ? pad : 64;
//   const top = Math.max(0, window.scrollY + quiz.getBoundingClientRect().top - offset);
//   const smooth = behavior === 'smooth';
//   window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
//   const restore = () => {
//     html.style.scrollBehavior = prevHtml;
//     if (body) body.style.scrollBehavior = prevBody;
//   };
//   if (smooth) window.setTimeout(restore, 700);
//   else restore();
//   return true;
// }
// function afterQuizLayout(fn){
//   requestAnimationFrame(() => {
//     requestAnimationFrame(fn);
//   });
// }
// function setText(id, text){
//   const el = $(id);
//   if (el) el.textContent = text;
// }
// function setHtml(id, html){
//   const el = $(id);
//   if (el) el.innerHTML = html;
// }

// function tally(answers){
//   const scores = { citrus:0, mint:0, daydream:0 };
//   answers.forEach((k) => { if (k in scores) scores[k] += 1; });
//   return scores;
// }

// function resolveWinner(answers){
//   const scores = tally(answers);
//   const max = Math.max(scores.citrus, scores.mint, scores.daydream);
//   const tied = ['citrus','mint','daydream'].filter((k) => scores[k] === max);
//   if (tied.length === 1) return tied[0];
//   for (let i = answers.length - 1; i >= 0; i--) {
//     if (tied.includes(answers[i])) return answers[i];
//   }
//   return tied[0] || 'citrus';
// }

// function resetQuiz(){
//   state.qi = 0;
//   state.lock = false;
//   state.answers = [];
//   state.scores = { citrus:0, mint:0, daydream:0 };
//   state.watchHoverPersona = null;
// }

// function flash(persona){
//   const el = $('flashOverlay');
//   if (el) {
//     el.style.background = '#fff';
//     el.classList.remove('on'); void el.offsetWidth; el.classList.add('on');
//     setTimeout(() => el.classList.remove('on'), 500);
//   }
//   if (persona) {
//     const qf = $('quizFlash');
//     const p = PERSONAS[persona];
//     if (qf && p) {
//       qf.style.background = p.color;
//       qf.style.opacity = 0.16;
//       setTimeout(() => { qf.style.opacity = 0; }, 260);
//     }
//   }
// }

// function showPanel(id){
//   document.querySelectorAll('.quiz-panel').forEach(p => p.classList.remove('active'));
//   const el = $(id);
//   if (el) el.classList.add('active');
//   if (typeof initHeroMorph._tick === 'function') initHeroMorph._tick();
// }

// window.addEventListener('resize', () => updateCardScale());

// function bindQuiz(){
//   on('startQuizBtn', 'click', () => {
//     resetQuiz();
//     flash();
//     setTimeout(() => {
//       state.stage = 'quiz';
//       showPanel('panelQuiz');
//       renderQuestion();
//       afterQuizLayout(() => {
//         pinQuizToViewport('auto');
//         window.setTimeout(() => pinQuizToViewport('auto'), 60);
//       });
//     }, 240);
//   });
//   on('backBtn', 'click', () => {
//     if (state.qi === 0) { state.stage = 'intro'; showPanel('panelIntro'); return; }
//     state.qi = Math.max(0, state.qi - 1);
//     state.answers = state.answers.slice(0, state.qi);
//     state.scores = tally(state.answers);
//     renderQuestion();
//   });
//   on('retakeBtn', 'click', () => {
//     resetQuiz();
//     state.stage = 'intro';
//     showPanel('panelIntro');
//   });
//   on('downloadBtn', 'click', downloadCard);
// }

// function renderTicks(){
//   const wrap = $('ticks');
//   if (wrap) {
//     wrap.innerHTML = '';
//     QUESTIONS.forEach((_, i) => {
//       const t = document.createElement('span');
//       t.className = 'tick' + (i <= state.qi ? ' done' : '');
//       wrap.appendChild(t);
//     });
//   }
//   setText('stepLabel', (Math.min(state.qi + 1, QUESTIONS.length)) + ' / ' + QUESTIONS.length);
// }

// function renderQuestion(){
//   renderTicks();
//   const qEl = $('quizQ');
//   const body = $('quizBody');
//   if (!qEl || !body) return;
//   const q = QUESTIONS[Math.min(state.qi, QUESTIONS.length - 1)];
//   qEl.textContent = q.q;
//   body.innerHTML = '';

//   if (q.reply) {
//     const reply = document.createElement('p');
//     reply.className = 'quiz-reply';
//     reply.textContent = q.reply;
//     body.appendChild(reply);
//   }

//   if (q.type === 'cards') {
//     const grid = document.createElement('div'); grid.className = 'opt-grid';
//     q.opts.forEach((o, i) => {
//       const b = document.createElement('button');
//       b.type = 'button';
//       b.className = 'opt-card'; b.textContent = o.label;
//       b.style.animationDelay = (i * 90) + 'ms';
//       b.style.setProperty('--accent', PERSONAS[o.persona].color);
//       b.onclick = () => advance(o.persona);
//       grid.appendChild(b);
//     });
//     body.appendChild(grid);
//   } else if (q.type === 'button') {
//     const row = document.createElement('div'); row.className = 'press-pills';
//     q.opts.forEach(o => {
//       const b = document.createElement('button'); b.type = 'button'; b.className = 'opt-pill'; b.textContent = o.label;
//       b.style.setProperty('--accent', PERSONAS[o.persona].color);
//       b.onclick = () => advance(o.persona);
//       row.appendChild(b);
//     });
//     body.appendChild(row);
//   } else if (q.type === 'portal') {
//     const row = document.createElement('div'); row.className = 'portal-row';
//     q.opts.forEach(o => {
//       const p = PERSONAS[o.persona];
//       const b = document.createElement('button'); b.type = 'button'; b.className = 'portal'; b.style.flex = '1'; b.style.background = p.tint;
//       b.innerHTML = `<span class="pdot" style="background:${p.color}"></span><span class="pname">${o.label}</span>`;
//       b.onmouseenter = () => { row.querySelectorAll('.portal').forEach(x => x.style.flex = x === b ? '2.4' : '0.8'); };
//       b.onmouseleave = () => { row.querySelectorAll('.portal').forEach(x => x.style.flex = '1'); };
//       b.onclick = () => advance(o.persona);
//       row.appendChild(b);
//     });
//     body.appendChild(row);
//   } else if (q.type === 'watch') {
//     const row = document.createElement('div'); row.className = 'watch-q-row';
//     const img = document.createElement('img'); img.className = 'watch-preview'; img.src = PERSONAS[state.watchHoverPersona || 'citrus'].img;
//     row.appendChild(img);
//     const opts = document.createElement('div'); opts.className = 'watch-opts';
//     q.opts.forEach(o => {
//       const b = document.createElement('button'); b.type = 'button'; b.className = 'opt-face'; b.textContent = o.label;
//       b.style.setProperty('--accent', PERSONAS[o.persona].color);
//       b.onmouseenter = () => { state.watchHoverPersona = o.persona; img.src = PERSONAS[o.persona].img; img.style.transform = `rotate(${o.persona==='citrus'?-8:o.persona==='daydream'?8:0}deg)`; };
//       b.onclick = () => advance(o.persona);
//       opts.appendChild(b);
//     });
//     row.appendChild(opts);
//     body.appendChild(row);
//   }
// }

// function advance(persona){
//   if (state.lock) return;
//   if (!PERSONAS[persona]) return;
//   state.lock = true;
//   flash(persona);
//   setTimeout(() => {
//     state.answers[state.qi] = persona;
//     state.answers = state.answers.slice(0, state.qi + 1);
//     state.qi += 1;
//     state.scores = tally(state.answers);
//     state.lock = false;
//     if (state.qi >= QUESTIONS.length) { runCalculating(); }
//     else { renderQuestion(); }
//   }, 260);
// }

// function runCalculating(){
//   const win = resolveWinner(state.answers);
//   state.persona = win;
//   state.colour = win;
//   state.scores = tally(state.answers);
//   state.stage = 'calculating';
//   showPanel('panelCalc');
//   afterQuizLayout(() => pinQuizToViewport('auto'));
//   const pct = $('calcPct');
//   const started = performance.now();
//   const duration = 1300;
//   const tick = (now) => {
//     if (state.stage !== 'calculating') return;
//     const progress = Math.min(1, (now - started) / duration);
//     const eased = 1 - Math.pow(1 - progress, 3);
//     if (pct) pct.textContent = Math.round(eased * 100) + '%';
//     if (progress < 1) {
//       requestAnimationFrame(tick);
//       return;
//     }
//     window.setTimeout(() => {
//       if (state.stage !== 'calculating') return;
//       state.stage = 'revealed';
//       showPanel('panelReveal');
//       renderReveal();
//       applyColourway(win);
//       afterQuizLayout(() => pinQuizToViewport('auto'));
//     }, 180);
//   };
//   requestAnimationFrame(tick);
// }

// /* ---- reveal card ---- */
// function renderReveal(){
//   const p = PERSONAS[state.persona] || PERSONAS.citrus;
//   const stage = $('revealStage');
//   if (stage) stage.dataset.pixie = p.key;
//   const cardBg = $('cardBg');
//   if (cardBg) { cardBg.src = p.life; cardBg.alt = p.name + ' polaroid'; }
//   setHtml('cardMark', MARK_SVG[p.mark](28));
//   const cardMark = $('cardMark'); if (cardMark) cardMark.style.color = p.color;
//   setText('cardName', p.name);
//   setText('revealVerdict', 'You are ' + p.name + '.');
//   setText('cardSubtitle', p.subtitle);
//   const linesEl = $('cardLines');
//   if (linesEl) linesEl.replaceChildren();

//   setText('revealBlurb', p.blurb);

//   const chaos = Math.min(96, state.scores.mint * 20 + 12);
//   const dream = Math.min(96, state.scores.daydream * 20 + 8);
//   const stats = [
//     { label:'Boring level', value:2, color:'var(--text-muted)' },
//     { label:'Chaos level', value:chaos, color:'var(--color-mint)' },
//     { label:'Daydream level', value:dream, color:'var(--color-daydream)' }
//   ];
//   setHtml('statsRow', stats.map(st => `<div class="stat"><div class="stat-val" style="color:${st.color}">${st.value}%</div><div class="stat-label">${st.label}</div></div>`).join(''));
//   updateCardScale();
// }

// function updateCardScale(){}

// function drawMark(x, key, cx, cy, r){
//   x.beginPath();
//   if (key === 'citrus') {
//     x.arc(cx, cy, r, 0, Math.PI*2); x.stroke();
//     x.beginPath(); x.arc(cx, cy, r*0.35, 0, Math.PI*2); x.stroke();
//     for (let i=0;i<8;i++){ const a=i*Math.PI/4;
//       x.beginPath(); x.moveTo(cx+Math.cos(a)*r*0.46, cy+Math.sin(a)*r*0.46); x.lineTo(cx+Math.cos(a)*r*0.92, cy+Math.sin(a)*r*0.92); x.stroke(); }
//   } else if (key === 'mint') {
//     x.moveTo(cx+r, cy-r);
//     x.bezierCurveTo(cx+r, cy+r*0.7, cx-r*0.2, cy+r, cx-r, cy+r);
//     x.bezierCurveTo(cx-r, cy-r*0.4, cx+r*0.1, cy-r, cx+r, cy-r);
//     x.stroke();
//     x.beginPath(); x.moveTo(cx-r, cy+r); x.quadraticCurveTo(cx-r*0.1, cy+r*0.2, cx+r*0.75, cy-r*0.5); x.stroke();
//   } else {
//     x.arc(cx-r*0.45, cy+r*0.15, r*0.5, Math.PI*0.6, Math.PI*1.9);
//     x.arc(cx+r*0.05, cy-r*0.25, r*0.6, Math.PI*1.1, Math.PI*2.05);
//     x.arc(cx+r*0.6, cy+r*0.2, r*0.45, Math.PI*1.6, Math.PI*0.5);
//     x.closePath(); x.stroke();
//   }
// }

// async function downloadCard(){
//   const p = PERSONAS[state.persona] || PERSONAS.citrus;
//   const filename = 'pixie-' + p.key + '-avatar.png';
//   let blob = null;
//   try {
//     const response = await fetch(p.life);
//     if (response.ok) blob = await response.blob();
//   } catch(e){}
//   const isAppleMobile = /iPhone|iPad|iPod/i.test(navigator.userAgent)
//     || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

//   if (blob && isAppleMobile && navigator.share) {
//     const file = new File([blob], filename, { type:'image/png' });
//     if (!navigator.canShare || navigator.canShare({ files:[file] })) {
//       try {
//         await navigator.share({
//           title: p.name + ' · Pebble Pixie',
//           text: 'Meet my Pebble Pixie avatar.',
//           files: [file]
//         });
//         return;
//       } catch (error) {
//         if (error && error.name === 'AbortError') return;
//       }
//     }
//   }

//   const a = document.createElement('a');
//   a.download = filename;
//   if (blob) {
//     const objectUrl = URL.createObjectURL(blob);
//     a.href = objectUrl;
//     a.click();
//     setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
//   } else {
//     a.href = p.life;
//     a.click();
//   }
// }

// function pixieShareUrl(){
//   const key = (state.persona && PERSONAS[state.persona]) ? state.persona : 'citrus';
//   const u = new URL(location.href);
//   u.searchParams.set('pixie', key);
//   u.hash = 'quiz';
//   return u.href;
// }

// async function copyPixieLink(){
//   const url = pixieShareUrl();
//   const btn = $('copyLinkBtn');
//   try {
//     if (navigator.clipboard && window.isSecureContext) {
//       await navigator.clipboard.writeText(url);
//     } else {
//       const ta = document.createElement('textarea');
//       ta.value = url;
//       ta.setAttribute('readonly', '');
//       ta.style.position = 'fixed';
//       ta.style.left = '-9999px';
//       document.body.appendChild(ta);
//       ta.select();
//       document.execCommand('copy');
//       ta.remove();
//     }
//     if (btn) {
//       const prev = btn.getAttribute('data-label') || btn.textContent;
//       btn.textContent = 'Copied';
//       setTimeout(() => { btn.textContent = prev; }, 1600);
//     }
//   } catch (e) {
//     if (btn) btn.textContent = 'copy failed';
//   }
// }

// function openSharedPixie(){
//   const key = new URLSearchParams(location.search).get('pixie');
//   if (!key || !PERSONAS[key]) return;
//   state.persona = key;
//   state.colour = key;
//   state.stage = 'revealed';
//   showPanel('panelReveal');
//   renderReveal();
//   applyColourway(key);
// }

// /* ---- features in motion (sticky stage + scrolling chapters) ---- */
// const FEATURE_KEYS = ['display', 'crown', 'health', 'smart'];
// let notesUnlocked = 0;
// let notesGoingUp = false;
// function paintFeatureNotes(count){
//   notesUnlocked = count;
//   document.querySelectorAll('#features .feature-notes .sticky-note').forEach((el) => {
//     const at = Number(el.dataset.noteAt || 99);
//     const show = at <= notesUnlocked;
//     if (show){
//       if (el.classList.contains('is-out-up')){
//         el.style.transition = 'none';
//         el.classList.remove('is-out-up', 'is-in');
//         void el.offsetWidth;
//         el.style.transition = '';
//       }
//       el.classList.add('is-in');
//       el.classList.remove('is-out-up');
//     } else {
//       el.classList.remove('is-in');
//       if (notesGoingUp) el.classList.add('is-out-up');
//     }
//   });
// }
// function unlockFeatureNotes(key){
//   const rank = { display: 1, crown: 2, health: 3, smart: 3 };
//   paintFeatureNotes(rank[key] || 0);
// }
// function setFeature(key, withNotes){
//   const reel = $('features');
//   if (!reel || !FEATURE_KEYS.includes(key)) return;
//   if (reel.dataset.feature !== key){
//     reel.dataset.feature = key;
//     reel.classList.remove('feature-display', 'feature-crown', 'feature-health', 'feature-smart');
//     reel.classList.add('feature-' + key);
//     reel.querySelectorAll('.feature-stage > .feature-stage-layer').forEach((el) => {
//       el.classList.toggle('active', el.dataset.layer === key);
//     });
//     const idx = $('featureIdx');
//     if (idx) idx.textContent = String(FEATURE_KEYS.indexOf(key) + 1).padStart(2, '0');
//   }
//   syncFeatureVids(key);
//   if (withNotes !== false) unlockFeatureNotes(key);
// }
// function syncFeatureVids(beat){
//   const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
//   const map = {
//     display: '[data-dome-vid]',
//     crown: '[data-haptic-vid]',
//     health: '[data-health-vid]',
//     smart: '[data-smart-vid]'
//   };
//   document.querySelectorAll('[data-dome-vid], [data-haptic-vid], [data-health-vid], [data-smart-vid]').forEach((v) => {
//     const host = v.closest('.feature-stage, .feature-chapter-visual');
//     const shown = host && host.offsetParent;
//     const sel = map[beat];
//     const should = !reduced && shown && sel && v.matches(sel);
//     if (should) v.play().catch(() => {});
//     else v.pause();
//   });
// }
// function sizeFeatureNotesBound(){
//   const bound = $('featureNotesBound');
//   const pin = document.querySelector('#features .feature-notes-pin');
//   if (pin) pin.removeAttribute('style');
//   if (!bound) return;
//   if (window.matchMedia('(max-width: 720px)').matches){
//     bound.style.height = '';
//     return;
//   }
//   const layout = document.querySelector('.feature-reel-layout');
//   const last = document.querySelector('[data-feature-chapter="smart"]') || document.querySelector('[data-feature-chapter="health"]');
//   if (!layout || !last) return;
//   const top = layout.getBoundingClientRect().top;
//   const end = last.getBoundingClientRect().bottom;
//   bound.style.height = Math.max(0, Math.round(end - top)) + 'px';
// }
// function featurePinLine(){
//   const stage = document.querySelector('#features .feature-stage');
//   if (stage && getComputedStyle(stage).display !== 'none'){
//     const r = stage.getBoundingClientRect();
//     if (r.height > 40) return r.top + r.height * 0.38;
//   }
//   return (window.innerHeight || 800) * 0.38;
// }
// function activeFeatureFromScroll(chapterEls){
//   const line = featurePinLine();
//   let key = null;
//   for (let i = 0; i < chapterEls.length; i++){
//     const ch = chapterEls[i];
//     if (ch.getBoundingClientRect().top <= line) key = ch.dataset.featureChapter || key;
//   }
//   return key;
// }
// function syncFeatureFromScroll(chapterEls){
//   const key = activeFeatureFromScroll(chapterEls);
//   const rank = { display: 1, crown: 2, health: 3, smart: 3 };
//   const next = key ? (rank[key] || 0) : 0;
//   notesGoingUp = next < notesUnlocked;
//   if (!key){
//     paintFeatureNotes(0);
//     setFeature('display', false);
//     return;
//   }
//   setFeature(key);
// }
// function initDomeSequence(){
//   const reel = $('features');
//   const chapter = document.querySelector('[data-feature-chapter="display"]');
//   const targets = Array.from(document.querySelectorAll('[data-dome-sequence]'));
//   if (!reel || !chapter || !targets.length) return;

//   const seed = targets[0].currentSrc || targets[0].src;
//   const urls = Array.from({ length: 50 }, (_, index) => {
//     const frame = String(index + 1).padStart(3, '0');
//     return seed.replace(/pixie-dial-frame-\d{3}\.jpg/, 'pixie-dial-frame-' + frame + '.jpg');
//   });
//   const frames = urls.map((url) => {
//     const image = new Image();
//     image.decoding = 'async';
//     image.src = url;
//     return image;
//   });
//   const framesReady = Promise.all(frames.map((image) => {
//     if (image.complete) return Promise.resolve();
//     return new Promise((resolve) => {
//       image.addEventListener('load', resolve, { once: true });
//       image.addEventListener('error', resolve, { once: true });
//     });
//   }));
//   let currentFrame = 49;
//   let playToken = 0;
//   let isOn = false;
//   let ticking = false;

//   const paint = (index) => {
//     if (index === currentFrame) return;
//     targets.forEach((target) => {
//       if (target.src !== urls[index]) target.src = urls[index];
//     });
//     currentFrame = index;
//   };

//   const animateTo = (targetFrame) => {
//     const token = ++playToken;
//     if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
//       paint(targetFrame);
//       return;
//     }
//     framesReady.then(() => {
//       if (token !== playToken) return;
//       const startFrame = currentFrame;
//       const distance = targetFrame - startFrame;
//       if (!distance) return;
//       const started = performance.now();
//       const duration = Math.max(260, 950 * Math.abs(distance) / 49);
//       const animate = (now) => {
//         if (token !== playToken) return;
//         const progress = Math.min(1, (now - started) / duration);
//         paint(Math.round(startFrame + distance * progress));
//         if (progress < 1) requestAnimationFrame(animate);
//       };
//       requestAnimationFrame(animate);
//     });
//   };

//   const watchNode = () => {
//     const stage = reel.querySelector('.feature-stage');
//     const chapterVisual = chapter.querySelector('.feature-chapter-visual');
//     if (stage && getComputedStyle(stage).display !== 'none') return stage;
//     return chapterVisual || targets[0];
//   };

//   const shouldTurnOn = () => {
//     const node = watchNode();
//     if (!node) return false;
//     const rect = node.getBoundingClientRect();
//     const mid = window.innerHeight * 0.5;
//     return rect.top <= mid && rect.bottom > window.innerHeight * 0.18;
//   };

//   const syncWatch = () => {
//     ticking = false;
//     const nextOn = shouldTurnOn();
//     if (nextOn === isOn) return;
//     isOn = nextOn;
//     animateTo(nextOn ? 0 : 49);
//   };

//   const onScroll = () => {
//     if (ticking) return;
//     ticking = true;
//     requestAnimationFrame(syncWatch);
//   };

//   window.addEventListener('scroll', onScroll, { passive: true });
//   window.addEventListener('resize', onScroll);
//   syncWatch();
// }
// function initFeatureReel(){
//   const reel = $('features');
//   const chapters = Array.from(document.querySelectorAll('[data-feature-chapter]'));
//   if (!reel || !chapters.length) return;
//   setFeature('display', false);
//   sizeFeatureNotesBound();
//   window.addEventListener('resize', sizeFeatureNotesBound);
//   window.addEventListener('scroll', () => {
//     syncFeatureFromScroll(chapters);
//   }, { passive: true });
//   if ('ResizeObserver' in window){
//     const ro = new ResizeObserver(sizeFeatureNotesBound);
//     ro.observe(reel);
//     const last = document.querySelector('[data-feature-chapter="smart"]') || document.querySelector('[data-feature-chapter="health"]');
//     if (last) ro.observe(last);
//   }
//   const onPin = () => {
//     syncFeatureFromScroll(chapters);
//   };
//   if (!('IntersectionObserver' in window)){
//     onPin();
//     return;
//   }
//   const obs = new IntersectionObserver(onPin, {
//     rootMargin: '-36% 0px -48% 0px',
//     threshold: [0, 0.08, 0.2, 0.4, 0.6, 0.8, 1]
//   });
//   chapters.forEach((ch) => obs.observe(ch));
//   obs.observe(reel);
//   onPin();
// }

// /* ---- swatch selector ---- */
// function paintSwatchRow(row, size, selectedBorder){
//   if (!row) return;
//   const isPersonas = row.id === 'swatchRow';
//   row.innerHTML = '';
//   ['citrus','mint','daydream'].forEach(key => {
//     const p = PERSONAS[key];
//     const selected = state.colour === key;
//     const b = document.createElement('button');
//     b.type = 'button';
//     b.className = 'swatch-dot' + (selected ? ' is-selected' : '');
//     b.setAttribute('aria-label', p.name);
//     b.setAttribute('aria-pressed', selected ? 'true' : 'false');
//     b.style.background = p.color;
//     if (!isPersonas) {
//       b.style.width = size;
//       b.style.height = size;
//       b.style.borderRadius = '50%';
//       b.style.cursor = 'pointer';
//       b.style.border = selected ? selectedBorder : '3px solid transparent';
//     }
//     b.onclick = () => applyColourway(key);
//     row.appendChild(b);
//   });
// }
// function applyColourway(key){
//   if (!PERSONAS[key]) return;
//   state.colour = key;
//   const footer = $('siteFooter');
//   if (footer) footer.dataset.pixie = key;
//   const club = $('club');
//   if (club) club.dataset.pixie = key;
//   const personas = $('personas');
//   if (personas) personas.dataset.pixie = key;
//   setText('clubChip', PERSONAS[key].name);
//   renderSwatches();
//   renderSwatchDisplay();
// }
// function renderSwatches(){
//   paintSwatchRow($('swatchRow'), '44px', '3px solid var(--color-ink)');
//   paintSwatchRow($('footerSwatches'), '22px', '3px solid var(--color-white)');
// }
// function renderSwatchDisplay(){
//   const p = PERSONAS[state.colour] || PERSONAS.citrus;
//   setHtml('swatchMark', MARK_SVG[p.key](34));
//   const mark = $('swatchMark'); if (mark) mark.style.color = p.color;
//   setText('swatchName', p.name);
//   const img = $('swatchImg'); if (img) img.src = p.img;
//   const atc = $('personasAtc');
//   if (atc){
//     delete atc.dataset.added;
//     const vid = pixieVariantId(p.key);
//     if (vid) atc.setAttribute('data-variant-id', vid);
//     else atc.removeAttribute('data-variant-id');
//     const routes = pixieRoutes();
//     const base = (routes.productUrls && routes.productUrls[p.key]) || '/products/pebble-pixie';
//     atc.setAttribute('href', vid ? (base + (base.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + vid) : base);
//   }
// }

// /* ---- footer accordion (mobile) ---- */
// const FOOTER_COLS = [
//   { title:'Quick links', links:[
//     { label:'New launches', href:'#hero' },
//     { label:'Pixie smartwatch', href:'#features' },
//     { label:'Straps & bands', href:'#straps' },
//     { label:'Accessories', href:'#faces' }
//   ]},
//   { title:'Company', links:[
//     { label:'About us', href:'#club' },
//     { label:'Careers', href:'#club' },
//     { label:'Press', href:'#club' },
//     { label:'Contact', href:'mailto:hello@pebble.com' }
//   ]},
//   { title:'Support', links:[
//     { label:'FAQs', href:'#features' },
//     { label:'Warranty policy', href:'#club' },
//     { label:'Track your order', href:'#club' },
//     { label:'Shipping & returns', href:'#club' }
//   ]}
// ];
// function renderFooter(){
//   const wrap = $('footerCols');
//   if (!wrap || wrap.dataset.static === '1') return;
//   wrap.innerHTML = '';
//   FOOTER_COLS.forEach(col => {
//     const box = document.createElement('div');
//     box.innerHTML = `
//       <button class="footer-toggle" data-col="${col.title}">
//         <span class="footer-col-title">${col.title}</span>
//         <span class="chev" style="transform:rotate(${state.footerOpen[col.title] ? 180 : 0}deg);transition:transform 380ms">▾</span>
//       </button>
//       <div class="footer-links${state.footerOpen[col.title] ? ' open' : ''}">
//         ${col.links.map(l => `<a href="${l.href}">${l.label}</a>`).join('')}
//       </div>`;
//     box.querySelector('.footer-toggle').onclick = () => {
//       state.footerOpen[col.title] = !state.footerOpen[col.title];
//       renderFooter();
//     };
//     wrap.appendChild(box);
//   });
// }

// /* ---- watchface showcase (native stills from standalone, no compressed mp4) ---- */
// const FACE_STILLS = A.faces || [];
// function fillFaceRow(row){
//   if (!row) return;
//   const loop = FACE_STILLS.concat(FACE_STILLS);
//   row.innerHTML = loop.map((src) => '<span><img src="' + src + '" alt=""></span>').join('');
// }
// function initFacesShowcase(){
//   const media = $('facesMedia');
//   const row = $('facesRow');
//   const inner = $('facesRowInner');
//   if (!media || !row || !inner) return;
//   fillFaceRow(row);
//   fillFaceRow(inner);
//   const rows = [row, inner];
//   const W = 1920;
//   const boxSize = 690;
//   const diam = 0.527 * boxSize;
//   const gap = diam * 0.32;
//   const pitch = diam + gap;
//   const stripWidth = pitch * FACE_STILLS.length;
//   const speed = stripWidth / 11.6;
//   const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
//   const fit = () => {
//     const w = media.clientWidth;
//     const h = media.clientHeight;
//     const s = w < 721
//       ? (w * 0.7) / 690
//       : Math.max(w / 1920, h / 1080);
//     media.style.setProperty('--faces-scale', String(s));
//   };
//   fit();
//   window.addEventListener('resize', fit, { passive: true });
//   let playing = false, origin = 0, held = 0, raf = 0;
//   const apply = (T) => {
//     const raw = ((T * speed) % stripWidth + stripWidth) % stripWidth;
//     const x = W / 2 - raw;
//     rows.forEach((el) => { el.style.transform = 'translate3d(' + x + 'px,0,0)'; });
//   };
//   const tick = (now) => {
//     if (!playing) return;
//     apply(held + (now - origin) / 1000);
//     raf = requestAnimationFrame(tick);
//   };
//   const play = () => {
//     if (reduced || playing) return;
//     playing = true;
//     origin = performance.now();
//     raf = requestAnimationFrame(tick);
//   };
//   const pause = () => {
//     if (!playing) return;
//     playing = false;
//     held += (performance.now() - origin) / 1000;
//     if (raf) cancelAnimationFrame(raf);
//   };
//   apply(0);
//   if (reduced) return;
//   if (!('IntersectionObserver' in window)){ play(); return; }
//   const io = new IntersectionObserver((entries) => {
//     entries.forEach((e) => { e.isIntersecting ? play() : pause(); });
//   }, { threshold: 0.2 });
//   io.observe(media);
// }

// /* ---- hero intro → plate ---- */
// function showHeroPlate(){
//   const hero = $('hero');
//   if (!hero) return;
//   hero.classList.remove('is-intro');
//   hero.classList.add('is-plate');
//   const intro = $('heroIntro');
//   if (intro) intro.setAttribute('aria-hidden', 'true');
//   if (intro) intro.removeAttribute('tabindex');
//   if (typeof initHeroMorph._tick === 'function') initHeroMorph._tick();
// }
// function initHeroIntro(){
//   const hero = $('hero');
//   const intro = $('heroIntro');
//   if (!hero) return;
//   const skip = window.matchMedia('(prefers-reduced-motion: reduce)').matches
//     || (location.hash && location.hash !== '#hero' && location.hash !== '#top');
//   if (skip){
//     showHeroPlate();
//     return;
//   }
//   let done = false;
//   const finish = () => {
//     if (done) return;
//     done = true;
//     showHeroPlate();
//   };
//   window.setTimeout(finish, 2800);
//   if (intro){
//     intro.addEventListener('click', finish);
//     intro.addEventListener('keydown', (e) => {
//       if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); finish(); }
//     });
//   }
// }

// /* ---- hero image morphs into quiz intro ---- */
// function initHeroMorph(){
//   const hero = $('hero');
//   const src = $('heroRender') || document.querySelector('#hero .hero-render');
//   const slot = $('quizHeroSlot');
//   const quiz = $('quiz');
//   const intro = $('panelIntro');
//   if (!hero || !src || !slot || !quiz) return;

//   const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
//   if (reduced){
//     slot.classList.add('is-filled');
//     return;
//   }

//   const fly = src.cloneNode(true);
//   fly.id = 'heroFly';
//   fly.className = 'hero-fly';
//   fly.removeAttribute('fetchpriority');
//   fly.removeAttribute('id');
//   fly.id = 'heroFly';
//   fly.alt = '';
//   fly.loading = 'eager';
//   document.body.appendChild(fly);

//   let raf = 0;
//   let landed = false;
//   const lerp = (a, b, t) => a + (b - a) * t;
//   const clamp01 = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);
//   const ease = (t) => 1 - Math.pow(1 - t, 3);

//   const tick = () => {
//     raf = 0;
//     const introOn = intro && intro.classList.contains('active');
//     const plated = hero.classList.contains('is-plate');
//     if (!introOn || !plated){
//       fly.classList.remove('is-on');
//       hero.classList.remove('is-morphing');
//       slot.classList.remove('is-filled');
//       hero.style.removeProperty('--hero-copy-fade');
//       landed = false;
//       return;
//     }

//     const quizTop = quiz.getBoundingClientRect().top;
//     const vh = window.innerHeight || 1;
//     const p = clamp01(1 - quizTop / vh);
//     hero.style.setProperty('--hero-copy-fade', String(Math.max(0, 1 - p * 1.45)));

//     if (p <= 0.012){
//       fly.classList.remove('is-on');
//       hero.classList.remove('is-morphing');
//       slot.classList.remove('is-filled');
//       landed = false;
//       return;
//     }

//     if (landed){
//       if (p < 0.78) landed = false;
//     } else if (p >= 0.86){
//       landed = true;
//     }

//     if (landed){
//       fly.classList.remove('is-on');
//       hero.classList.add('is-morphing');
//       slot.classList.add('is-filled');
//       return;
//     }

//     const start = src.getBoundingClientRect();
//     const end = slot.getBoundingClientRect();
//     if (start.width < 8 || end.width < 8) return;

//     slot.classList.remove('is-filled');
//     hero.classList.add('is-morphing');
//     fly.classList.add('is-on');

//     const e = ease(p);
//     const mobile = window.matchMedia('(max-width: 720px)').matches;
//     const popIn = (!mobile && p < 0.28) ? 1 + 0.22 * Math.sin((p / 0.28) * Math.PI) : 1;
//     const landT = p > 0.62 ? (p - 0.62) / 0.24 : 0;
//     const popOut = (!mobile && landT > 0) ? 1 + 0.16 * Math.sin(Math.min(landT, 1) * Math.PI) : 1;
//     const scale = (lerp(start.width, end.width, e) / start.width) * popIn * popOut;
//     const startCx = start.left + start.width * 0.5;
//     const startCy = start.top + start.height * 0.5;
//     const endCx = end.left + end.width * 0.5;
//     const endCy = end.top + end.height * 0.5;
//     const cx = mobile ? startCx : lerp(startCx, endCx, e);
//     const cy = lerp(startCy, endCy, e);
//     fly.style.width = start.width + 'px';
//     fly.style.height = start.height + 'px';
//     fly.style.transform = 'translate(' + (cx - start.width * 0.5) + 'px,' + (cy - start.height * 0.5) + 'px) scale(' + scale + ')';
//   };

//   const requestTick = () => {
//     if (raf) return;
//     raf = requestAnimationFrame(tick);
//   };
//   initHeroMorph._tick = requestTick;

//   window.addEventListener('scroll', requestTick, { passive: true });
//   window.addEventListener('resize', requestTick, { passive: true });
//   requestTick();
// }

// function initFilmMarquee(){
//   const viewport = document.querySelector('.pixie-page .quiz-film-viewport');
//   const track = document.querySelector('.pixie-page .quiz-film-track');
//   if (!viewport || !track) return;
//   const seed = track.querySelector('.quiz-film-run');
//   if (!seed || !seed.children.length) return;

//   track.querySelectorAll('img').forEach((img) => {
//     img.loading = 'eager';
//     img.decoding = 'async';
//   });

//   const PX_PER_SEC = 46;
//   const originals = [...seed.children].filter((n) => !n.hasAttribute('data-film-extra'));
//   let resizeTimer = 0;

//   const fill = () => {
//     const viewW = viewport.getBoundingClientRect().width;
//     if (viewW < 8 || !originals.length) return;

//     track.querySelectorAll('[data-film-clone]').forEach((n) => n.remove());
//     seed.querySelectorAll('[data-film-extra]').forEach((n) => n.remove());
//     let guard = 0;
//     while (seed.getBoundingClientRect().width < viewW + 8 && guard++ < 16) {
//       originals.forEach((node) => {
//         const clone = node.cloneNode(true);
//         clone.removeAttribute('id');
//         clone.setAttribute('data-film-extra', '');
//         seed.appendChild(clone);
//       });
//     }

//     const runW = seed.getBoundingClientRect().width;
//     const html = seed.innerHTML;
//     let runs = [...track.querySelectorAll('.quiz-film-run')];
//     if (runs.length === 1) {
//       const copy = seed.cloneNode(true);
//       copy.setAttribute('aria-hidden', 'true');
//       copy.setAttribute('data-film-clone', '');
//       track.appendChild(copy);
//       runs = [...track.querySelectorAll('.quiz-film-run')];
//     }
//     runs.slice(1).forEach((run) => {
//       run.innerHTML = html;
//       run.setAttribute('aria-hidden', 'true');
//     });

//     let total = runW * track.querySelectorAll('.quiz-film-run').length;
//     while (total < viewW * 3) {
//       const copy = seed.cloneNode(true);
//       copy.setAttribute('aria-hidden', 'true');
//       copy.setAttribute('data-film-clone', '');
//       track.appendChild(copy);
//       total += runW;
//     }

//     track.style.setProperty('--film-shift', runW + 'px');
//     track.style.setProperty('--film-duration', Math.max(18, runW / PX_PER_SEC) + 's');
//     track.classList.add('is-looping');
//   };

//   const schedule = () => {
//     window.clearTimeout(resizeTimer);
//     resizeTimer = window.setTimeout(fill, 80);
//   };

//   fill();
//   Promise.all([...seed.querySelectorAll('img')].map((img) => {
//     if (img.complete) return Promise.resolve();
//     return new Promise((resolve) => {
//       img.addEventListener('load', resolve, { once: true });
//       img.addEventListener('error', resolve, { once: true });
//     });
//   })).then(fill);

//   window.addEventListener('resize', schedule, { passive: true });
// }

// /* ---- init ---- */
// try { initHeroIntro(); } catch (e) {}
// try { initHeroMorph(); } catch (e) {}
// try { initDomeSequence(); } catch (e) {}
// try { initFeatureReel(); } catch (e) {}
// try { initFilmMarquee(); } catch (e) {}
// try { applyColourway(state.colour); } catch (e) {}
// try { openSharedPixie(); } catch (e) {}
// try { renderFooter(); } catch (e) {}
// try { initFacesShowcase(); } catch (e) {}
// try {
//   document.querySelectorAll('#footerCols[data-static="1"] .footer-toggle').forEach((btn) => {
//     btn.addEventListener('click', () => {
//       const links = btn.nextElementSibling;
//       if (!links) return;
//       const open = links.classList.toggle('open');
//       const chev = btn.querySelector('.chev');
//       if (chev) chev.style.transform = 'rotate(' + (open ? 180 : 0) + 'deg)';
//     });
//   });
// } catch (e) {}
// function pixieRoutes(){
//   return window.PIXIE_ROUTES || {};
// }
// function pixieRoot(){
//   const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
//   return root || '/';
// }
// function pixieCartAddUrl(){
//   const add = pixieRoutes().cartAdd || (pixieRoot() + 'cart/add');
//   if (/\.js(\?|$)/.test(add)) return add;
//   return add.replace(/\/?(\?|$)/, '.js$1');
// }
// function pixieVariantId(key){
//   const routes = pixieRoutes();
//   const mapped = routes.variants && routes.variants[key];
//   if (mapped) return mapped;
//   const btn = $('personasAtc');
//   return (btn && btn.getAttribute('data-variant-id')) || null;
// }
// function pixieBindNativeCartDrawer(drawer){
//   if (!drawer || drawer._pixiePortalBound || !document.body.classList.contains('tem-pebble-pixie')) return;
//   const home = drawer.parentNode;
//   const marker = document.createComment('pixie-cart-drawer-home');
//   home.insertBefore(marker, drawer);
//   const portal = () => {
//     if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
//   };
//   const restore = () => {
//     window.setTimeout(() => {
//       const details = drawer.querySelector('details');
//       if (details && details.open) return;
//       if (marker.parentNode && drawer.parentNode !== marker.parentNode) {
//         marker.parentNode.insertBefore(drawer, marker.nextSibling);
//       }
//     }, 450);
//   };
//   const summary = drawer.querySelector('.cart-drawer-container > summary');
//   if (summary) summary.addEventListener('click', portal, { capture: true });
//   drawer.addEventListener('close', restore);
//   drawer._pixiePortal = portal;
//   drawer._pixiePortalBound = true;
// }
// function pixieCartDrawer(){
//   const drawer = document.querySelector('cart-drawer');
//   const usesNativeHeader = document.body.classList.contains('tem-pebble-pixie');
//   if (drawer && drawer.closest('#shopify-section-header')) {
//     if (usesNativeHeader) {
//       pixieBindNativeCartDrawer(drawer);
//       drawer._pixiePortal();
//     } else {
//       document.body.appendChild(drawer);
//     }
//   }
//   return drawer;
// }
// function pixieMiniCart(){
//   const drawer = pixieCartDrawer();
//   return (drawer && drawer.querySelector('mini-cart')) || document.querySelector('mini-cart');
// }
// function pixieOpenCart(){
//   const miniCart = pixieMiniCart();
//   if (miniCart && typeof miniCart.open === 'function') {
//     miniCart.open();
//     return true;
//   }
//   const drawer = pixieCartDrawer();
//   if (drawer && typeof drawer.open === 'function') {
//     drawer.open();
//     return true;
//   }
//   const summary = drawer
//     ? drawer.querySelector('.cart-drawer-container > summary')
//     : document.querySelector('.cart-drawer-container > summary, #shopify-section-header summary.header__icon--cart');
//   if (drawer && summary && typeof drawer.openMenuDrawer === 'function') {
//     const details = summary.closest('details');
//     if (details) details.setAttribute('open', '');
//     drawer.openMenuDrawer(summary);
//     return true;
//   }
//   if (summary) {
//     summary.click();
//     return true;
//   }
//   window.location.href = pixieRoot() + 'cart';
//   return false;
// }
// function pixieUpdateCartCount(count){
//   const el = $('pixieCartCount');
//   if (!el) return;
//   const n = Number(count) || 0;
//   el.textContent = String(n);
//   el.hidden = n < 1;
// }
// function pixieRefreshCartCount(){
//   fetch(pixieRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } })
//     .then((res) => res.json())
//     .then((cart) => pixieUpdateCartCount(cart && cart.item_count))
//     .catch(() => {});
// }
// function pixieMatchVariant(product, key){
//   const variants = (product && product.variants) || [];
//   const needles = {
//     citrus: ['citrus', 'spark', 'orange'],
//     mint: ['mint', 'mischief', 'green'],
//     daydream: ['daydream', 'dreamy', 'blue']
//   }[key] || [];
//   const found = variants.find((v) => {
//     const hay = [v.title, v.option1, v.option2, v.option3].filter(Boolean).join(' ').toLowerCase();
//     return needles.some((n) => hay.indexOf(n) !== -1);
//   });
//   if (found) return found.id;
//   return variants[0] ? variants[0].id : null;
// }
// function pixieResolveVariant(key){
//   const known = pixieVariantId(key);
//   if (known) return Promise.resolve(Number(known));
//   const routes = pixieRoutes();
//   if (routes._resolving) return routes._resolving.then(() => {
//     const id = pixieVariantId(key);
//     return id ? Number(id) : null;
//   });
//   const handles = (routes.handles && routes.handles.length)
//     ? routes.handles
//     : ['pebble-pixie', 'pixie', 'pixie-smartwatch', 'pebble-pixie-smartwatch'];
//   routes._resolving = (async () => {
//     for (let i = 0; i < handles.length; i++) {
//       try {
//         const res = await fetch(pixieRoot() + 'products/' + handles[i] + '.js');
//         if (!res.ok) continue;
//         const product = await res.json();
//         routes.variants = routes.variants || {};
//         routes.productUrls = routes.productUrls || {};
//         ['citrus', 'mint', 'daydream'].forEach((k) => {
//           if (!routes.variants[k]) routes.variants[k] = pixieMatchVariant(product, k);
//           if (!routes.productUrls[k]) routes.productUrls[k] = product.url;
//         });
//         window.PIXIE_ROUTES = routes;
//         return;
//       } catch (e) {}
//     }
//   })();
//   return routes._resolving.then(() => {
//     const id = pixieVariantId(key);
//     return id ? Number(id) : null;
//   });
// }
// function pixieAddToCart(variantId){
//   const miniCart = pixieMiniCart();
//   const sections = (miniCart && typeof miniCart.getSectionsToRender === 'function')
//     ? miniCart.getSectionsToRender().map((s) => s.id)
//     : ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
//   return fetch(pixieCartAddUrl(), {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       'Accept': 'application/json',
//       'X-Requested-With': 'XMLHttpRequest'
//     },
//     body: JSON.stringify({
//       items: [{ id: Number(variantId), quantity: 1 }],
//       sections: sections.join(','),
//       sections_url: window.location.pathname
//     })
//   }).then((res) => res.json().then((data) => ({ ok: res.ok, data }))).then(({ ok, data }) => {
//     if (!ok) {
//       throw new Error((data && (data.description || data.message)) || 'Unable to add this item');
//     }
//     if (data && data.status && (data.message || data.description)) {
//       throw new Error(data.description || data.message);
//     }
//     if (miniCart && typeof miniCart.renderContents === 'function' && data && data.sections) {
//       miniCart.renderContents(data);
//     }
//     document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
//     document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
//     document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data } }));
//     if (typeof window.triggerCartUpdate === 'function') window.triggerCartUpdate();
//     pixieOpenCart();
//     const cart = data && (data.cart || data);
//     if (cart && typeof cart.item_count !== 'undefined') pixieUpdateCartCount(cart.item_count);
//     else pixieRefreshCartCount();
//     return data;
//   });
// }

// bindQuiz();
// document.addEventListener('click', (e) => {
//   const btn = e.target.closest('[data-pixie-atc]');
//   if (!btn || btn.dataset.busy) return;
//   e.preventDefault();
//   const p = PERSONAS[state.colour] || PERSONAS.citrus;
//   const label = btn.querySelector('#personasAtcLabel');
//   const originalLabel = label ? label.textContent : btn.textContent;
//   const setLabel = (text) => {
//     if (label) label.textContent = text;
//     else btn.textContent = text;
//   };
//   btn.dataset.busy = '1';
//   btn.setAttribute('aria-disabled', 'true');
//   if ('disabled' in btn) btn.disabled = true;
//   setLabel('Adding…');
//   pixieResolveVariant(p.key).then((variantId) => {
//     if (!variantId) {
//       throw new Error('Pixie product is not assigned');
//     }
//     return pixieAddToCart(variantId).then(() => {
//       setLabel('Added to cart');
//     });
//   }).catch((error) => {
//     console.error('Pixie add to cart:', error);
//     setLabel('Product unavailable');
//   }).finally(() => {
//     window.setTimeout(() => {
//       delete btn.dataset.busy;
//       btn.removeAttribute('aria-disabled');
//       if ('disabled' in btn) btn.disabled = false;
//       setLabel(originalLabel);
//     }, 1600);
//   });
// });
// on('pixieCartBtn', 'click', (e) => {
//   e.preventDefault();
//   pixieOpenCart();
// });
// try {
//   const nativeDrawer = document.querySelector('cart-drawer');
//   pixieBindNativeCartDrawer(nativeDrawer);
// } catch (e) {}
// try { pixieRefreshCartCount(); } catch (e) {}
// on('logoBtn', 'click', () => {
//   const url = location.pathname + location.search;
//   if (location.hash) history.replaceState(null, '', url);
//   window.scrollTo({ top: 0, behavior: 'smooth' });
// });

// document.addEventListener('click', (e) => {
//   const heroColor = e.target.closest('[data-hero-color]');
//   if (heroColor) {
//     const hero = heroColor.closest('#hero');
//     if (!hero) return;
//     const colors = {
//       citrus: '#f0921f',
//       mint: '#7dc496',
//       daydream: '#93c4d6'
//     };
//     const key = heroColor.dataset.heroColor;
//     if (!colors[key]) return;
//     hero.style.setProperty('--hero-accent', colors[key]);
//     hero.querySelectorAll('[data-hero-color]').forEach((option) => {
//       const active = option === heroColor;
//       option.classList.toggle('is-active', active);
//       option.setAttribute('aria-pressed', active ? 'true' : 'false');
//     });
//     return;
//   }

//   const strapColor = e.target.closest('[data-strap-src]');
//   if (strapColor) {
//     const straps = strapColor.closest('#straps');
//     const image = straps && straps.querySelector('[data-strap-visual] img');
//     if (!straps || !image) return;
//     const key = strapColor.dataset.strapColor;
//     const styles = getComputedStyle(straps.closest('.pixie-page') || straps);
//     const colors = {
//       citrus: styles.getPropertyValue('--color-citrus').trim(),
//       mint: styles.getPropertyValue('--color-mint').trim(),
//       daydream: styles.getPropertyValue('--color-daydream').trim()
//     };
//     if (!colors[key]) return;
//     straps.dataset.strapColor = key;
//     straps.style.backgroundColor = colors[key];
//     image.style.opacity = '0';
//     window.setTimeout(() => {
//       image.src = strapColor.dataset.strapSrc;
//       image.removeAttribute('srcset');
//       image.alt = strapColor.getAttribute('aria-label') || 'Pixie watch';
//       image.style.opacity = '1';
//     }, 140);
//     straps.querySelectorAll('[data-strap-src]').forEach((option) => {
//       const active = option === strapColor;
//       option.classList.toggle('is-active', active);
//       option.setAttribute('aria-pressed', active ? 'true' : 'false');
//     });
//     return;
//   }

//   const btn = e.target.closest('[data-lifestyle-color]');
//   if (!btn) return;
//   const section = btn.closest('#lifestyle');
//   const watch = section && section.querySelector('[data-lifestyle-watch] img');
//   if (!section || !watch) return;
//   const key = btn.dataset.lifestyleColor;
//   const galleryImages = [1, 2, 3, 4]
//     .map((index) => section.querySelector('#lifestyleImage' + index))
//     .filter(Boolean);
//   section.querySelectorAll('[data-lifestyle-color]').forEach((option) => {
//     const active = option === btn;
//     option.classList.toggle('active', active);
//     option.setAttribute('aria-pressed', active ? 'true' : 'false');
//   });
//   const bento = section.querySelector('.lifestyle-bento');
//   if (bento) bento.dataset.lifestyleTheme = key;
//   [...galleryImages, watch].forEach((image) => { image.style.opacity = '0'; });
//   window.setTimeout(() => {
//     galleryImages.forEach((image, index) => {
//       const src = btn.getAttribute('data-image-' + (index + 1));
//       if (src) image.src = src;
//       image.removeAttribute('srcset');
//       image.alt = btn.textContent.trim() + ' campaign image ' + (index + 1);
//       image.style.opacity = '1';
//     });
//     watch.src = btn.dataset.watchSrc;
//     watch.removeAttribute('srcset');
//     watch.alt = btn.textContent.trim() + ' Pixie watch';
//     watch.style.opacity = '1';
//   }, 140);
// });

// function pixieScrollToId(id){
//   if (!id) return false;
//   if (id === 'quiz') return pinQuizToViewport('smooth');
//   const el = document.getElementById(id) || (id === 'atc' ? $('personas') : null);
//   if (!el) return false;
//   el.scrollIntoView({ behavior: 'smooth', block: 'start' });
//   return true;
// }
// document.addEventListener('click', (e) => {
//   const a = e.target.closest('a[data-pixie-scroll], a.hero-cta');
//   if (!a) return;
//   const attr = a.getAttribute('data-pixie-scroll');
//   const href = a.getAttribute('href') || '';
//   let id = attr || '';
//   if (!id && href.charAt(0) === '#') id = href.slice(1);
//   if (!id){
//     try {
//       const u = new URL(href, location.href);
//       if (u.hash) id = u.hash.slice(1);
//     } catch (err) {}
//   }
//   if (pixieScrollToId(id)) e.preventDefault();
// });

// })();
